
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5NM1t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $3Xy6U = parcelRequire("3Xy6U");
var $61mwv = parcelRequire("61mwv");
var $4396c7a6d1e7f95a$var$init = module.exports.init = function init() {
    (0, $3Xy6U.init)({
        dsn: "https://2f6fc09d0448fddb3c470e956349b361@o4508091834236928.ingest.de.sentry.io/4508092891463760",
        integrations: [
            (0, $61mwv.browserTracingIntegration)()
        ],
        tracesSampleRate: 0.05,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.0
    });
};

});
parcelRegister("3Xy6U", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $2e21576465f5ccd3$export$2cd8252107eb640b; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $lRxbG = parcelRequire("lRxbG");
var $hcXGp = parcelRequire("hcXGp");
var $dRRV8 = parcelRequire("dRRV8");
var $4vOpL = parcelRequire("4vOpL");
var $lwEDW = parcelRequire("lwEDW");
var $3TBFY = parcelRequire("3TBFY");
var $8aNUP = parcelRequire("8aNUP");
var $59F2f = parcelRequire("59F2f");
var $3HlBY = parcelRequire("3HlBY");
var $kHMxW = parcelRequire("kHMxW");
var $cn3Tr = parcelRequire("cn3Tr");

var $8HbQZ = parcelRequire("8HbQZ");

var $TSWQd = parcelRequire("TSWQd");

var $cBmnW = parcelRequire("cBmnW");

var $dMmcE = parcelRequire("dMmcE");

var $6ESHT = parcelRequire("6ESHT");

var $ck2N4 = parcelRequire("ck2N4");

var $hMCun = parcelRequire("hMCun");

var $57j5s = parcelRequire("57j5s");

var $bPeEv = parcelRequire("bPeEv");

var $7F7Fy = parcelRequire("7F7Fy");

var $8aOJO = parcelRequire("8aOJO");
/** Get the default integrations for the browser SDK. */ function $2e21576465f5ccd3$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $lRxbG.inboundFiltersIntegration)(),
        (0, $hcXGp.functionToStringIntegration)(),
        (0, $6ESHT.browserApiErrorsIntegration)(),
        (0, $dMmcE.breadcrumbsIntegration)(),
        (0, $hMCun.globalHandlersIntegration)(),
        (0, $bPeEv.linkedErrorsIntegration)(),
        (0, $dRRV8.dedupeIntegration)(),
        (0, $57j5s.httpContextIntegration)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $ck2N4.browserSessionIntegration)());
    return integrations;
}
function $2e21576465f5ccd3$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $2e21576465f5ccd3$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $cBmnW.WINDOW).SENTRY_RELEASE && (0, $cBmnW.WINDOW).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $cBmnW.WINDOW).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return (0, $jHMUv._)({}, defaultOptions, optionsArg);
}
function $2e21576465f5ccd3$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $cBmnW.WINDOW).window !== "undefined" && (0, $cBmnW.WINDOW);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $cBmnW.WINDOW).location && (0, $cBmnW.WINDOW).location.href || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $cBmnW.WINDOW) === (0, $cBmnW.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $2e21576465f5ccd3$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $2e21576465f5ccd3$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $2e21576465f5ccd3$var$shouldShowBrowserExtensionError()) {
        (0, $4vOpL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $TSWQd.DEBUG_BUILD) {
        if (!(0, $lwEDW.supportsFetch)()) (0, $4vOpL.logger).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = (0, $hYccX._)((0, $jHMUv._)({}, options), {
        stackParser: (0, $3TBFY.stackParserFromStackParserOptions)(options.stackParser || (0, $7F7Fy.defaultStackParser)),
        integrations: (0, $8aNUP.getIntegrationsToSetup)(options),
        transport: options.transport || (0, $8aOJO.makeFetchTransport)
    });
    return (0, $59F2f.initAndBind)((0, $8HbQZ.BrowserClient), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $2e21576465f5ccd3$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $cBmnW.WINDOW).document) {
        (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $3HlBY.getCurrentScope)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = (0, $jHMUv._)({}, scope.getUser(), options.user);
    if (!options.eventId) {
        const eventId = (0, $kHMxW.lastEventId)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $cBmnW.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $cn3Tr.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $cBmnW.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $cBmnW.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $cBmnW.WINDOW).document.head || (0, $cBmnW.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2e21576465f5ccd3$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2e21576465f5ccd3$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $2e21576465f5ccd3$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $3HlBY.getClient)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}

});
parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$71511d61b312f219; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d624443cd99befe$export$71511d61b312f219; });
function $3d624443cd99befe$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$71511d61b312f219; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("lRxbG", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $fea84a922b407fce$export$cb3c5c2ceb9818ba; });

var $ilsq0 = parcelRequire("ilsq0");

var $8aNUP = parcelRequire("8aNUP");

var $4vOpL = parcelRequire("4vOpL");

var $3Swz7 = parcelRequire("3Swz7");

var $j3Pr8 = parcelRequire("j3Pr8");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $fea84a922b407fce$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $fea84a922b407fce$var$INTEGRATION_NAME = "InboundFilters";
const $fea84a922b407fce$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $fea84a922b407fce$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $fea84a922b407fce$var$_mergeOptions(options, clientOptions);
            return $fea84a922b407fce$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $fea84a922b407fce$export$cb3c5c2ceb9818ba = (0, $8aNUP.defineIntegration)($fea84a922b407fce$var$_inboundFiltersIntegration);
function $fea84a922b407fce$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $fea84a922b407fce$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $fea84a922b407fce$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $fea84a922b407fce$var$_isSentryError(event)) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $3Swz7.getEventDescription)(event)}`);
        return true;
    }
    if ($fea84a922b407fce$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $3Swz7.getEventDescription)(event)}`);
        return true;
    }
    if ($fea84a922b407fce$var$_isUselessError(event)) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $3Swz7.getEventDescription)(event)}`);
        return true;
    }
    if ($fea84a922b407fce$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $3Swz7.getEventDescription)(event)}`);
        return true;
    }
    if ($fea84a922b407fce$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $3Swz7.getEventDescription)(event)}.\nUrl: ${$fea84a922b407fce$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$fea84a922b407fce$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $3Swz7.getEventDescription)(event)}.\nUrl: ${$fea84a922b407fce$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $fea84a922b407fce$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $fea84a922b407fce$var$_getPossibleEventMessages(event).some((message)=>(0, $j3Pr8.stringMatchesSomePattern)(message, ignoreErrors));
}
function $fea84a922b407fce$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $j3Pr8.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $fea84a922b407fce$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $fea84a922b407fce$var$_getEventFilterUrl(event);
    return !url ? false : (0, $j3Pr8.stringMatchesSomePattern)(url, denyUrls);
}
function $fea84a922b407fce$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $fea84a922b407fce$var$_getEventFilterUrl(event);
    return !url ? true : (0, $j3Pr8.stringMatchesSomePattern)(url, allowUrls);
}
function $fea84a922b407fce$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $fea84a922b407fce$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $fea84a922b407fce$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $fea84a922b407fce$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $fea84a922b407fce$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).error(`Cannot extract url for event ${(0, $3Swz7.getEventDescription)(event)}`);
        return null;
    }
}
function $fea84a922b407fce$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}

});
parcelRegister("ilsq0", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $d5b03b7898b49ab4$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d5b03b7898b49ab4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("8aNUP", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $5f35fa17102926db$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $5f35fa17102926db$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $5f35fa17102926db$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $5f35fa17102926db$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "defineIntegration", function () { return $5f35fa17102926db$export$2323046b9414659f; });

var $3HlBY = parcelRequire("3HlBY");

var $ilsq0 = parcelRequire("ilsq0");

var $4vOpL = parcelRequire("4vOpL");
const $5f35fa17102926db$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $5f35fa17102926db$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $5f35fa17102926db$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $5f35fa17102926db$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === "Debug");
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $5f35fa17102926db$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $5f35fa17102926db$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $5f35fa17102926db$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $5f35fa17102926db$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($5f35fa17102926db$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $5f35fa17102926db$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $5f35fa17102926db$export$2d8f5188773bcddd(integration) {
    const client = (0, $3HlBY.getClient)();
    if (!client) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $5f35fa17102926db$export$2323046b9414659f(fn) {
    return fn;
}

});
parcelRegister("3HlBY", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", function () { return $2b1626dc6c4dbe3a$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $2b1626dc6c4dbe3a$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $2b1626dc6c4dbe3a$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $2b1626dc6c4dbe3a$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $2b1626dc6c4dbe3a$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $2b1626dc6c4dbe3a$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "getTraceContextFromScope", function () { return $2b1626dc6c4dbe3a$export$1e83db7ee4876dc4; });

var $33sJY = parcelRequire("33sJY");

var $3dQJg = parcelRequire("3dQJg");

var $eEH2K = parcelRequire("eEH2K");

var $6qGSh = parcelRequire("6qGSh");

var $0167p = parcelRequire("0167p");
/**
 * Get the currently active scope.
 */ function $2b1626dc6c4dbe3a$export$c7be4b0125a10cba() {
    const carrier = (0, $3dQJg.getMainCarrier)();
    const acs = (0, $33sJY.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $2b1626dc6c4dbe3a$export$68f3af03034c9e90() {
    const carrier = (0, $3dQJg.getMainCarrier)();
    const acs = (0, $33sJY.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $2b1626dc6c4dbe3a$export$aa55d5ab8e05984f() {
    return (0, $0167p.getGlobalSingleton)("globalScope", ()=>new (0, $eEH2K.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $2b1626dc6c4dbe3a$export$ec58d9285c204497(...rest) {
    const carrier = (0, $3dQJg.getMainCarrier)();
    const acs = (0, $33sJY.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $2b1626dc6c4dbe3a$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $3dQJg.getMainCarrier)();
    const acs = (0, $33sJY.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $2b1626dc6c4dbe3a$export$6bb76d6eba7e258c() {
    return $2b1626dc6c4dbe3a$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $2b1626dc6c4dbe3a$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $6qGSh.dropUndefinedKeys)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}

});
parcelRegister("33sJY", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $2397f233953880af$export$f639b0c2752203be; });

var $3dQJg = parcelRequire("3dQJg");

var $kzOzo = parcelRequire("kzOzo");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $2397f233953880af$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $3dQJg.getMainCarrier)();
    const sentry = (0, $3dQJg.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $2397f233953880af$export$f639b0c2752203be(carrier) {
    const sentry = (0, $3dQJg.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $kzOzo.getStackAsyncContextStrategy)();
}

});
parcelRegister("3dQJg", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $258b7ce4deb37994$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $258b7ce4deb37994$export$c8bfa33e4e8ae492; });

var $k6Tr9 = parcelRequire("k6Tr9");

var $0167p = parcelRequire("0167p");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $258b7ce4deb37994$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $258b7ce4deb37994$export$c8bfa33e4e8ae492((0, $0167p.GLOBAL_OBJ));
    return 0, $0167p.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $258b7ce4deb37994$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $k6Tr9.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $k6Tr9.SDK_VERSION] = __SENTRY__[0, $k6Tr9.SDK_VERSION] || {};
}

});
parcelRegister("k6Tr9", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $ea3f5ecc5e083dd6$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $ea3f5ecc5e083dd6$export$31499a9cd224b78c = "8.54.0";

});

parcelRegister("0167p", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $0034d71a4658abec$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $0034d71a4658abec$export$7e223ec222791509; });

var $k6Tr9 = parcelRequire("k6Tr9");
/** Get's the global object for the current JavaScript runtime */ const $0034d71a4658abec$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $0034d71a4658abec$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $0034d71a4658abec$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $k6Tr9.SDK_VERSION] = __SENTRY__[0, $k6Tr9.SDK_VERSION] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}

});


parcelRegister("kzOzo", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $efae4da2a93b995d$export$329d4d4d54e42710; });

var $k0GpF = parcelRequire("k0GpF");

var $eEH2K = parcelRequire("eEH2K");

var $3xKQd = parcelRequire("3xKQd");

var $3dQJg = parcelRequire("3dQJg");
/**
 * This is an object that holds a stack of scopes.
 */ class $efae4da2a93b995d$export$d36ec451f120cfba {
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $3xKQd.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $eEH2K.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $eEH2K.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $efae4da2a93b995d$var$getAsyncContextStack() {
    const registry = (0, $3dQJg.getMainCarrier)();
    const sentry = (0, $3dQJg.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $efae4da2a93b995d$export$d36ec451f120cfba((0, $k0GpF.getDefaultCurrentScope)(), (0, $k0GpF.getDefaultIsolationScope)());
}
function $efae4da2a93b995d$var$withScope(callback) {
    return $efae4da2a93b995d$var$getAsyncContextStack().withScope(callback);
}
function $efae4da2a93b995d$var$withSetScope(scope, callback) {
    const stack = $efae4da2a93b995d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $efae4da2a93b995d$var$withIsolationScope(callback) {
    return $efae4da2a93b995d$var$getAsyncContextStack().withScope(()=>{
        return callback($efae4da2a93b995d$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $efae4da2a93b995d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $efae4da2a93b995d$var$withIsolationScope,
        withScope: $efae4da2a93b995d$var$withScope,
        withSetScope: $efae4da2a93b995d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $efae4da2a93b995d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$efae4da2a93b995d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$efae4da2a93b995d$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("k0GpF", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $e914b518518060d7$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $e914b518518060d7$export$de9862929b76bf57; });

var $eEH2K = parcelRequire("eEH2K");

var $0167p = parcelRequire("0167p");
/** Get the default current scope. */ function $e914b518518060d7$export$6f1b9191db9c4d5() {
    return (0, $0167p.getGlobalSingleton)("defaultCurrentScope", ()=>new (0, $eEH2K.Scope)());
}
/** Get the default isolation scope. */ function $e914b518518060d7$export$de9862929b76bf57() {
    return (0, $0167p.getGlobalSingleton)("defaultIsolationScope", ()=>new (0, $eEH2K.Scope)());
}

});
parcelRegister("eEH2K", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $aab6309a3fc8713c$export$775b6bb06e53a214; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $2sNxu = parcelRequire("2sNxu");

var $3xKQd = parcelRequire("3xKQd");

var $4vOpL = parcelRequire("4vOpL");

var $3Swz7 = parcelRequire("3Swz7");

var $01dJv = parcelRequire("01dJv");

var $iBQWV = parcelRequire("iBQWV");

var $foynR = parcelRequire("foynR");

var $fvhzj = parcelRequire("fvhzj");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $aab6309a3fc8713c$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $aab6309a3fc8713c$var$ScopeClass {
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $aab6309a3fc8713c$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = (0, $jHMUv._)({}, this._tags);
        newScope._extra = (0, $jHMUv._)({}, this._extra);
        newScope._contexts = (0, $jHMUv._)({}, this._contexts);
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = (0, $jHMUv._)({}, this._sdkProcessingMetadata);
        newScope._propagationContext = (0, $jHMUv._)({}, this._propagationContext);
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $fvhzj._setSpanForScope)(newScope, (0, $fvhzj._getSpanForScope)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $2sNxu.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = (0, $jHMUv._)({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = (0, $hYccX._)((0, $jHMUv._)({}, this._tags), {
            [key]: value
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = (0, $jHMUv._)({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = (0, $hYccX._)((0, $jHMUv._)({}, this._extra), {
            [key]: extra
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $aab6309a3fc8713c$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $3xKQd.isPlainObject)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = (0, $jHMUv._)({}, this._tags, tags);
        this._extra = (0, $jHMUv._)({}, this._extra, extra);
        this._contexts = (0, $jHMUv._)({}, this._contexts, contexts);
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $fvhzj._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $01dJv.generateTraceId)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $aab6309a3fc8713c$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = (0, $jHMUv._)({
            timestamp: (0, $iBQWV.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            if (this._client) this._client.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $fvhzj._getSpanForScope)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $foynR.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = (0, $jHMUv._)({
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $01dJv.generateSpanId)()
        }, context);
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3Swz7.uuid4)();
        if (!this._client) {
            (0, $4vOpL.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, (0, $hYccX._)((0, $jHMUv._)({
            originalException: exception,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3Swz7.uuid4)();
        if (!this._client) {
            (0, $4vOpL.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, (0, $hYccX._)((0, $jHMUv._)({
            originalException: message,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3Swz7.uuid4)();
        if (!this._client) {
            (0, $4vOpL.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, (0, $hYccX._)((0, $jHMUv._)({}, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $01dJv.generateTraceId)(),
            spanId: (0, $01dJv.generateSpanId)()
        };
    }
}
/**
 * Holds additional event information.
 */ const $aab6309a3fc8713c$export$775b6bb06e53a214 = $aab6309a3fc8713c$var$ScopeClass;

});
parcelRegister("2sNxu", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $1cb49fc4442a0d07$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $1cb49fc4442a0d07$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $1cb49fc4442a0d07$export$56521d9ba90f62ee; });



var $6qGSh = parcelRequire("6qGSh");

var $iBQWV = parcelRequire("iBQWV");

var $3Swz7 = parcelRequire("3Swz7");

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $1cb49fc4442a0d07$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $iBQWV.timestampInSeconds)();
    const session = {
        sid: (0, $3Swz7.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$1cb49fc4442a0d07$var$sessionToJSON(session)
    };
    if (context) $1cb49fc4442a0d07$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $1cb49fc4442a0d07$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $iBQWV.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $3Swz7.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $1cb49fc4442a0d07$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $1cb49fc4442a0d07$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $1cb49fc4442a0d07$var$sessionToJSON(session) {
    return (0, $6qGSh.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});
parcelRegister("6qGSh", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $4ae66dc620cfca78$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $4ae66dc620cfca78$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $4ae66dc620cfca78$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $4ae66dc620cfca78$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $4ae66dc620cfca78$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $4ae66dc620cfca78$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $4ae66dc620cfca78$export$d25f2688db1bb433; });

var $jHMUv = parcelRequire("jHMUv");

var $iv9z6 = parcelRequire("iv9z6");

var $8y3nO = parcelRequire("8y3nO");

var $3xKQd = parcelRequire("3xKQd");

var $4vOpL = parcelRequire("4vOpL");

var $j3Pr8 = parcelRequire("j3Pr8");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $4ae66dc620cfca78$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $4ae66dc620cfca78$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $8y3nO.DEBUG_BUILD) && (0, $4vOpL.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $4ae66dc620cfca78$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $8y3nO.DEBUG_BUILD) && (0, $4vOpL.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $4ae66dc620cfca78$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $4ae66dc620cfca78$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4ae66dc620cfca78$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ae66dc620cfca78$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $4ae66dc620cfca78$export$62ff257738bf57f5(value) {
    if ((0, $3xKQd.isError)(value)) return (0, $jHMUv._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $4ae66dc620cfca78$var$getOwnProperties(value));
    else if ((0, $3xKQd.isEvent)(value)) {
        const newObj = (0, $jHMUv._)({
            type: value.type,
            target: $4ae66dc620cfca78$var$serializeEventTarget(value.target),
            currentTarget: $4ae66dc620cfca78$var$serializeEventTarget(value.currentTarget)
        }, $4ae66dc620cfca78$var$getOwnProperties(value));
        if (typeof CustomEvent !== "undefined" && (0, $3xKQd.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $4ae66dc620cfca78$var$serializeEventTarget(target) {
    try {
        return (0, $3xKQd.isElement)(target) ? (0, $iv9z6.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $4ae66dc620cfca78$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $4ae66dc620cfca78$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($4ae66dc620cfca78$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $j3Pr8.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $j3Pr8.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $4ae66dc620cfca78$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $4ae66dc620cfca78$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $4ae66dc620cfca78$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($4ae66dc620cfca78$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $4ae66dc620cfca78$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($4ae66dc620cfca78$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $4ae66dc620cfca78$var$isPojo(input) {
    if (!(0, $3xKQd.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $4ae66dc620cfca78$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $3xKQd.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("iv9z6", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $d7828ab027750eaf$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $d7828ab027750eaf$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $d7828ab027750eaf$export$c660c1f3ab49225c; });
$parcel$export(module.exports, "getComponentName", function () { return $d7828ab027750eaf$export$26727cfcc4d7e0fc; });

var $3xKQd = parcelRequire("3xKQd");

var $0167p = parcelRequire("0167p");
const $d7828ab027750eaf$var$WINDOW = (0, $0167p.GLOBAL_OBJ);
const $d7828ab027750eaf$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d7828ab027750eaf$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d7828ab027750eaf$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d7828ab027750eaf$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d7828ab027750eaf$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($d7828ab027750eaf$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $3xKQd.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $d7828ab027750eaf$export$1cfafeee2987818b() {
    try {
        return $d7828ab027750eaf$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d7828ab027750eaf$export$c660c1f3ab49225c(selector) {
    if ($d7828ab027750eaf$var$WINDOW.document && $d7828ab027750eaf$var$WINDOW.document.querySelector) return $d7828ab027750eaf$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $d7828ab027750eaf$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$d7828ab027750eaf$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("3xKQd", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $2948c9dab99fef16$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $2948c9dab99fef16$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $2948c9dab99fef16$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $2948c9dab99fef16$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $2948c9dab99fef16$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $2948c9dab99fef16$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $2948c9dab99fef16$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $2948c9dab99fef16$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $2948c9dab99fef16$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $2948c9dab99fef16$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $2948c9dab99fef16$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $2948c9dab99fef16$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $2948c9dab99fef16$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $2948c9dab99fef16$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $2948c9dab99fef16$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $2948c9dab99fef16$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$e6127cc7fe7395c3(wat) {
    switch($2948c9dab99fef16$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $2948c9dab99fef16$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$var$isBuiltin(wat, className) {
    return $2948c9dab99fef16$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$9f9636d330b71954(wat) {
    return $2948c9dab99fef16$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$ef9e2056653f0c8e(wat) {
    return $2948c9dab99fef16$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$12e869b2a583f783(wat) {
    return $2948c9dab99fef16$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$844ec244b1367d54(wat) {
    return $2948c9dab99fef16$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$c3825b437cbdea5c(wat) {
    return wat === null || $2948c9dab99fef16$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$53b83ca8eaab0383(wat) {
    return $2948c9dab99fef16$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $2948c9dab99fef16$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $2948c9dab99fef16$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$49841c62b9eff15(wat) {
    return $2948c9dab99fef16$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $2948c9dab99fef16$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$bc2894c7158efbac(wat) {
    return $2948c9dab99fef16$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2948c9dab99fef16$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});


parcelRegister("8y3nO", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $63941f855f19a62d$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $63941f855f19a62d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("4vOpL", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $349129ee88dd453b$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $349129ee88dd453b$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $349129ee88dd453b$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $349129ee88dd453b$export$af88d00dbe7f521; });

var $8y3nO = parcelRequire("8y3nO");

var $0167p = parcelRequire("0167p");
/** Prefix for logging strings */ const $349129ee88dd453b$var$PREFIX = "Sentry Logger ";
const $349129ee88dd453b$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $349129ee88dd453b$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $349129ee88dd453b$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $0167p.GLOBAL_OBJ))) return callback();
    const console = (0, $0167p.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($349129ee88dd453b$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $349129ee88dd453b$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $349129ee88dd453b$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $8y3nO.DEBUG_BUILD) $349129ee88dd453b$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $349129ee88dd453b$export$cda52e2a8927a2ca(()=>{
                (0, $0167p.GLOBAL_OBJ).console[name](`${$349129ee88dd453b$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $349129ee88dd453b$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $349129ee88dd453b$export$af88d00dbe7f521 = (0, $0167p.getGlobalSingleton)("logger", $349129ee88dd453b$var$makeLogger);

});

parcelRegister("j3Pr8", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $de0632673fcbf147$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $de0632673fcbf147$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $de0632673fcbf147$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $de0632673fcbf147$export$a7a5ec66062ea5d; });

var $3xKQd = parcelRequire("3xKQd");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $de0632673fcbf147$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $de0632673fcbf147$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $de0632673fcbf147$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $3xKQd.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $de0632673fcbf147$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $3xKQd.isString)(value)) return false;
    if ((0, $3xKQd.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $3xKQd.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $de0632673fcbf147$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$de0632673fcbf147$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});


parcelRegister("iBQWV", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $037f0b605717308d$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $037f0b605717308d$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $037f0b605717308d$export$baf075a948ffc0bf; });

var $0167p = parcelRequire("0167p");
const $037f0b605717308d$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $037f0b605717308d$export$7740643b9eeaf0c4() {
    return Date.now() / $037f0b605717308d$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $037f0b605717308d$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $0167p.GLOBAL_OBJ);
    if (!performance || !performance.now) return $037f0b605717308d$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $037f0b605717308d$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $037f0b605717308d$export$ee52dced521e3e18 = $037f0b605717308d$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $037f0b605717308d$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $037f0b605717308d$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $0167p.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $037f0b605717308d$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $037f0b605717308d$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $037f0b605717308d$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $037f0b605717308d$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("3Swz7", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $2d2fad0dfe870bcf$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $2d2fad0dfe870bcf$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $2d2fad0dfe870bcf$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $2d2fad0dfe870bcf$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $2d2fad0dfe870bcf$export$6de4ffac6a2f1098; });

var $jHMUv = parcelRequire("jHMUv");

var $6qGSh = parcelRequire("6qGSh");

var $j3Pr8 = parcelRequire("j3Pr8");

var $0167p = parcelRequire("0167p");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $2d2fad0dfe870bcf$export$19f53698e68b2496() {
    const gbl = (0, $0167p.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $2d2fad0dfe870bcf$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $2d2fad0dfe870bcf$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $2d2fad0dfe870bcf$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $2d2fad0dfe870bcf$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $2d2fad0dfe870bcf$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $2d2fad0dfe870bcf$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $jHMUv._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        const mergedData = (0, $jHMUv._)({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $2d2fad0dfe870bcf$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $2d2fad0dfe870bcf$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $2d2fad0dfe870bcf$export$d364f2020ab30578(input) {
    const match = input.match($2d2fad0dfe870bcf$var$SEMVER_REGEXP) || [];
    const major = $2d2fad0dfe870bcf$var$_parseInt(match[1]);
    const minor = $2d2fad0dfe870bcf$var$_parseInt(match[2]);
    const patch = $2d2fad0dfe870bcf$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $2d2fad0dfe870bcf$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $j3Pr8.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $j3Pr8.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $j3Pr8.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $2d2fad0dfe870bcf$export$6de4ffac6a2f1098(exception) {
    if ($2d2fad0dfe870bcf$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $6qGSh.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $2d2fad0dfe870bcf$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $2d2fad0dfe870bcf$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});


parcelRegister("01dJv", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", function () { return $003abf2e5deab55f$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $003abf2e5deab55f$export$295213bc4d0c54ad; });

var $3Swz7 = parcelRequire("3Swz7");
/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $003abf2e5deab55f$export$37f0f2f9cf343e5e() {
    return {
        traceId: $003abf2e5deab55f$export$dc6d7ea554bcce10(),
        spanId: $003abf2e5deab55f$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $003abf2e5deab55f$export$dc6d7ea554bcce10() {
    return (0, $3Swz7.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $003abf2e5deab55f$export$295213bc4d0c54ad() {
    return (0, $3Swz7.uuid4)().substring(16);
}

});

parcelRegister("foynR", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $b353c4d6e299e1c1$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ 
var $jHMUv = parcelRequire("jHMUv");
function $b353c4d6e299e1c1$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = (0, $jHMUv._)({}, initialObj);
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $b353c4d6e299e1c1$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("fvhzj", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", function () { return $b497610959425fc1$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $b497610959425fc1$export$91f063ebb8eff307; });

var $6qGSh = parcelRequire("6qGSh");
const $b497610959425fc1$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $b497610959425fc1$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $6qGSh.addNonEnumerableProperty)(scope, $b497610959425fc1$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$b497610959425fc1$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $b497610959425fc1$export$91f063ebb8eff307(scope) {
    return scope[$b497610959425fc1$var$SCOPE_SPAN_FIELD];
}

});








parcelRegister("hcXGp", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $c871da793e9b1e96$export$7918117e9202e4fb; });

var $3HlBY = parcelRequire("3HlBY");

var $8aNUP = parcelRequire("8aNUP");

var $6qGSh = parcelRequire("6qGSh");
let $c871da793e9b1e96$var$originalFunctionToString;
const $c871da793e9b1e96$var$INTEGRATION_NAME = "FunctionToString";
const $c871da793e9b1e96$var$SETUP_CLIENTS = new WeakMap();
const $c871da793e9b1e96$var$_functionToStringIntegration = ()=>{
    return {
        name: $c871da793e9b1e96$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $c871da793e9b1e96$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $6qGSh.getOriginalFunction)(this);
                    const context = $c871da793e9b1e96$var$SETUP_CLIENTS.has((0, $3HlBY.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $c871da793e9b1e96$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $c871da793e9b1e96$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $c871da793e9b1e96$export$7918117e9202e4fb = (0, $8aNUP.defineIntegration)($c871da793e9b1e96$var$_functionToStringIntegration);

});

parcelRegister("dRRV8", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $a18a0d1ac28ab25b$export$6d39aa44cd0c7567; });

var $8aNUP = parcelRequire("8aNUP");

var $ilsq0 = parcelRequire("ilsq0");

var $4vOpL = parcelRequire("4vOpL");

var $3TBFY = parcelRequire("3TBFY");
const $a18a0d1ac28ab25b$var$INTEGRATION_NAME = "Dedupe";
const $a18a0d1ac28ab25b$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $a18a0d1ac28ab25b$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($a18a0d1ac28ab25b$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $a18a0d1ac28ab25b$export$6d39aa44cd0c7567 = (0, $8aNUP.defineIntegration)($a18a0d1ac28ab25b$var$_dedupeIntegration);
/** only exported for tests. */ function $a18a0d1ac28ab25b$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($a18a0d1ac28ab25b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($a18a0d1ac28ab25b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $a18a0d1ac28ab25b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$a18a0d1ac28ab25b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a18a0d1ac28ab25b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $a18a0d1ac28ab25b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $a18a0d1ac28ab25b$var$_getExceptionFromEvent(previousEvent);
    const currentException = $a18a0d1ac28ab25b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$a18a0d1ac28ab25b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a18a0d1ac28ab25b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $a18a0d1ac28ab25b$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $3TBFY.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $3TBFY.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $a18a0d1ac28ab25b$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $a18a0d1ac28ab25b$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}

});
parcelRegister("3TBFY", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $2d63bbd5aa06d79e$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $2d63bbd5aa06d79e$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $2d63bbd5aa06d79e$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $2d63bbd5aa06d79e$export$aad197c7121a6651; });
$parcel$export(module.exports, "getFramesFromEvent", function () { return $2d63bbd5aa06d79e$export$91d8ca51bd9f6a47; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");
const $2d63bbd5aa06d79e$var$STACKTRACE_FRAME_LIMIT = 50;
const $2d63bbd5aa06d79e$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $2d63bbd5aa06d79e$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $2d63bbd5aa06d79e$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $2d63bbd5aa06d79e$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $2d63bbd5aa06d79e$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($2d63bbd5aa06d79e$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $2d63bbd5aa06d79e$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $2d63bbd5aa06d79e$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $2d63bbd5aa06d79e$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $2d63bbd5aa06d79e$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $2d63bbd5aa06d79e$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($2d63bbd5aa06d79e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($2d63bbd5aa06d79e$var$STRIP_FRAME_REGEXP.test($2d63bbd5aa06d79e$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($2d63bbd5aa06d79e$var$STRIP_FRAME_REGEXP.test($2d63bbd5aa06d79e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $2d63bbd5aa06d79e$var$STACKTRACE_FRAME_LIMIT).map((frame)=>(0, $hYccX._)((0, $jHMUv._)({}, frame), {
            filename: frame.filename || $2d63bbd5aa06d79e$var$getLastStackFrame(localStack).filename,
            function: frame.function || $2d63bbd5aa06d79e$export$27c7e15d453fc0ac
        }));
}
function $2d63bbd5aa06d79e$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $2d63bbd5aa06d79e$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $2d63bbd5aa06d79e$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $2d63bbd5aa06d79e$var$defaultFunctionName;
        return fn.name || $2d63bbd5aa06d79e$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $2d63bbd5aa06d79e$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $2d63bbd5aa06d79e$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});


parcelRegister("lwEDW", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $fabc1d0aca476100$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFunction", function () { return $fabc1d0aca476100$export$d5f608b368e73f38; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $fabc1d0aca476100$export$c82d238e23c40b21; });

var $8y3nO = parcelRequire("8y3nO");

var $4vOpL = parcelRequire("4vOpL");

var $0167p = parcelRequire("0167p");
const $fabc1d0aca476100$var$WINDOW = (0, $0167p.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $fabc1d0aca476100$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $fabc1d0aca476100$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $fabc1d0aca476100$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $fabc1d0aca476100$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $fabc1d0aca476100$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $fabc1d0aca476100$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $fabc1d0aca476100$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$fabc1d0aca476100$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($fabc1d0aca476100$export$d5f608b368e73f38($fabc1d0aca476100$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $fabc1d0aca476100$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $fabc1d0aca476100$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $8y3nO.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $fabc1d0aca476100$export$531055a6c684a70a() {
    return "ReportingObserver" in $fabc1d0aca476100$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $fabc1d0aca476100$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$fabc1d0aca476100$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("59F2f", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $3c0d9fc0886f3fcb$export$5333c3f1c58d9bc1; });

var $3HlBY = parcelRequire("3HlBY");

var $ilsq0 = parcelRequire("ilsq0");

var $4vOpL = parcelRequire("4vOpL");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $3c0d9fc0886f3fcb$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $ilsq0.DEBUG_BUILD) (0, $4vOpL.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $4vOpL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $3HlBY.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $3c0d9fc0886f3fcb$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $3c0d9fc0886f3fcb$export$ecb76f41d43c0e43(client) {
    (0, $3HlBY.getCurrentScope)().setClient(client);
}

});

parcelRegister("kHMxW", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $f12d7b1972ae881e$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureEvent", function () { return $f12d7b1972ae881e$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "lastEventId", function () { return $f12d7b1972ae881e$export$5d4e9fd7fac8e617; });
$parcel$export(module.exports, "isEnabled", function () { return $f12d7b1972ae881e$export$3b029eb57ac4d562; });
$parcel$export(module.exports, "startSession", function () { return $f12d7b1972ae881e$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $f12d7b1972ae881e$export$667e7b4d445d566b; });

var $jHMUv = parcelRequire("jHMUv");

var $9MURR = parcelRequire("9MURR");

var $3HlBY = parcelRequire("3HlBY");

var $ilsq0 = parcelRequire("ilsq0");

var $2sNxu = parcelRequire("2sNxu");

var $3xKQd = parcelRequire("3xKQd");

var $4vOpL = parcelRequire("4vOpL");

var $3Swz7 = parcelRequire("3Swz7");

var $iBQWV = parcelRequire("iBQWV");

var $0167p = parcelRequire("0167p");

var $izym6 = parcelRequire("izym6");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f12d7b1972ae881e$export$f5282963edea4a68(exception, hint) {
    return (0, $3HlBY.getCurrentScope)().captureException(exception, (0, $izym6.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f12d7b1972ae881e$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $3HlBY.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f12d7b1972ae881e$export$1462b974fdcf6ba2(event, hint) {
    return (0, $3HlBY.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f12d7b1972ae881e$export$2f04de43fe27971a(name, context) {
    (0, $3HlBY.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f12d7b1972ae881e$export$bb4922da0dd51b92(extras) {
    (0, $3HlBY.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f12d7b1972ae881e$export$8e8e7789d42ed61d(key, extra) {
    (0, $3HlBY.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f12d7b1972ae881e$export$74a8fb34822092e6(tags) {
    (0, $3HlBY.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f12d7b1972ae881e$export$a37d07ee78eb4569(key, value) {
    (0, $3HlBY.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f12d7b1972ae881e$export$8b6bb3dd62a01be2(user) {
    (0, $3HlBY.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f12d7b1972ae881e$export$5d4e9fd7fac8e617() {
    return (0, $3HlBY.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f12d7b1972ae881e$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $3HlBY.getCurrentScope)();
    const client = (0, $3HlBY.getClient)();
    if (!client) (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $3Swz7.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f12d7b1972ae881e$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f12d7b1972ae881e$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $iBQWV.timestampInSeconds)();
    function finishCheckIn(status) {
        $f12d7b1972ae881e$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $iBQWV.timestampInSeconds)() - now
        });
    }
    return (0, $3HlBY.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $3xKQd.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f12d7b1972ae881e$export$4909b86c8034bf73(timeout) {
    const client = (0, $3HlBY.getClient)();
    if (client) return client.flush(timeout);
    (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f12d7b1972ae881e$export$8360e631d277ea4d(timeout) {
    const client = (0, $3HlBY.getClient)();
    if (client) return client.close(timeout);
    (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f12d7b1972ae881e$export$3f95c6f800b78024() {
    return !!(0, $3HlBY.getClient)();
}
/** If the SDK is initialized & enabled. */ function $f12d7b1972ae881e$export$3b029eb57ac4d562() {
    const client = (0, $3HlBY.getClient)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f12d7b1972ae881e$export$9aac0b9f77928fbf(callback) {
    (0, $3HlBY.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f12d7b1972ae881e$export$c0d84948cecf78d8(context) {
    const client = (0, $3HlBY.getClient)();
    const isolationScope = (0, $3HlBY.getIsolationScope)();
    const currentScope = (0, $3HlBY.getCurrentScope)();
    const { release: release, environment: environment = (0, $9MURR.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $0167p.GLOBAL_OBJ).navigator || {};
    const session = (0, $2sNxu.makeSession)((0, $jHMUv._)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $2sNxu.updateSession)(currentSession, {
        status: "exited"
    });
    $f12d7b1972ae881e$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f12d7b1972ae881e$export$17a5be43989a0bc1() {
    const isolationScope = (0, $3HlBY.getIsolationScope)();
    const currentScope = (0, $3HlBY.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $2sNxu.closeSession)(session);
    $f12d7b1972ae881e$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f12d7b1972ae881e$var$_sendSessionUpdate() {
    const isolationScope = (0, $3HlBY.getIsolationScope)();
    const currentScope = (0, $3HlBY.getCurrentScope)();
    const client = (0, $3HlBY.getClient)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f12d7b1972ae881e$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f12d7b1972ae881e$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f12d7b1972ae881e$var$_sendSessionUpdate();
}

});
parcelRegister("9MURR", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $7204b57aa380c90c$export$849dbeeeda01ae98; });
const $7204b57aa380c90c$export$849dbeeeda01ae98 = "production";

});

parcelRegister("izym6", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $d856252599272a93$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $d856252599272a93$export$76b5f966996d1653; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $9MURR = parcelRequire("9MURR");

var $3HlBY = parcelRequire("3HlBY");

var $57urs = parcelRequire("57urs");

var $eEH2K = parcelRequire("eEH2K");

var $kmiCD = parcelRequire("kmiCD");

var $3Swz7 = parcelRequire("3Swz7");

var $3vGYX = parcelRequire("3vGYX");

var $j3Pr8 = parcelRequire("j3Pr8");

var $iBQWV = parcelRequire("iBQWV");

var $eNTBV = parcelRequire("eNTBV");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $d856252599272a93$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = (0, $hYccX._)((0, $jHMUv._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $3Swz7.uuid4)(),
        timestamp: event.timestamp || (0, $iBQWV.dateTimestampInSeconds)()
    });
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $d856252599272a93$export$d7e04067a6fbc882(prepared, options);
    $d856252599272a93$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $d856252599272a93$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $d856252599272a93$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $3Swz7.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $3HlBY.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $eNTBV.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $eNTBV.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $eNTBV.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $57urs.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $d856252599272a93$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $d856252599272a93$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $d856252599272a93$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $9MURR.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $j3Pr8.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $j3Pr8.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $j3Pr8.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $d856252599272a93$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $kmiCD.getFilenameToDebugIdMap)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $d856252599272a93$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $d856252599272a93$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $d856252599272a93$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = (0, $jHMUv._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map((b)=>(0, $jHMUv._)({}, b, b.data && {
                data: (0, $3vGYX.normalize)(b.data, depth, maxBreadth)
            }))
    }, event.user && {
        user: (0, $3vGYX.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $3vGYX.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $3vGYX.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $3vGYX.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return (0, $jHMUv._)({}, span, span.data && {
            data: (0, $3vGYX.normalize)(span.data, depth, maxBreadth)
        });
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $3vGYX.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $d856252599272a93$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $eEH2K.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $d856252599272a93$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($d856252599272a93$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($d856252599272a93$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $d856252599272a93$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $eEH2K.Scope) || typeof hint === "function";
}
const $d856252599272a93$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $d856252599272a93$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$d856252599272a93$var$captureContextKeys.includes(key));
}

});
parcelRegister("57urs", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", function () { return $3ba5385561cc4870$export$bf2a096c3e883e79; });

var $jHMUv = parcelRequire("jHMUv");

var $ilsq0 = parcelRequire("ilsq0");

var $3xKQd = parcelRequire("3xKQd");

var $4vOpL = parcelRequire("4vOpL");

var $3UQvo = parcelRequire("3UQvo");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $3ba5385561cc4870$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $3UQvo.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor((0, $jHMUv._)({}, event), hint);
            (0, $ilsq0.DEBUG_BUILD) && processor.id && result === null && (0, $4vOpL.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $3xKQd.isThenable)(result)) result.then((final)=>$3ba5385561cc4870$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $3ba5385561cc4870$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("3UQvo", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $2d9f548666da6eeb$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $2d9f548666da6eeb$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $2d9f548666da6eeb$export$78e43115b553f358; });

var $3xKQd = parcelRequire("3xKQd");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $2d9f548666da6eeb$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($2d9f548666da6eeb$var$States || ($2d9f548666da6eeb$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $2d9f548666da6eeb$export$1fda8aa4d135f8aa(value) {
    return new $2d9f548666da6eeb$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $2d9f548666da6eeb$export$78e43115b553f358(reason) {
    return new $2d9f548666da6eeb$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $2d9f548666da6eeb$export$6f292d4960313241 {
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $2d9f548666da6eeb$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $2d9f548666da6eeb$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($2d9f548666da6eeb$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($2d9f548666da6eeb$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $2d9f548666da6eeb$var$States.PENDING) return;
            if ((0, $3xKQd.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $2d9f548666da6eeb$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $2d9f548666da6eeb$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $2d9f548666da6eeb$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
    constructor(executor){
        $2d9f548666da6eeb$export$6f292d4960313241.prototype.__init.call(this);
        $2d9f548666da6eeb$export$6f292d4960313241.prototype.__init2.call(this);
        $2d9f548666da6eeb$export$6f292d4960313241.prototype.__init3.call(this);
        $2d9f548666da6eeb$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $2d9f548666da6eeb$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
}

});


parcelRegister("kmiCD", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", function () { return $ed244eb406233c0b$export$e069fee9c632ed00; });

var $0167p = parcelRequire("0167p");
let $ed244eb406233c0b$var$parsedStackResults;
let $ed244eb406233c0b$var$lastKeysCount;
let $ed244eb406233c0b$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $ed244eb406233c0b$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $0167p.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($ed244eb406233c0b$var$cachedFilenameDebugIds && debugIdKeys.length === $ed244eb406233c0b$var$lastKeysCount) return $ed244eb406233c0b$var$cachedFilenameDebugIds;
    $ed244eb406233c0b$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $ed244eb406233c0b$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$ed244eb406233c0b$var$parsedStackResults) $ed244eb406233c0b$var$parsedStackResults = {};
        const result = $ed244eb406233c0b$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $ed244eb406233c0b$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $ed244eb406233c0b$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $ed244eb406233c0b$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $ed244eb406233c0b$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("3vGYX", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $28e59bb8ab06add2$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $28e59bb8ab06add2$export$23fbbb20bed71033; });

var $3xKQd = parcelRequire("3xKQd");

var $apjyK = parcelRequire("apjyK");

var $6qGSh = parcelRequire("6qGSh");

var $3TBFY = parcelRequire("3TBFY");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28e59bb8ab06add2$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $28e59bb8ab06add2$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $28e59bb8ab06add2$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $28e59bb8ab06add2$export$a3295358bff77e(object, depth);
    if ($28e59bb8ab06add2$var$jsonSize(normalized) > maxSize) return $28e59bb8ab06add2$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $28e59bb8ab06add2$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $apjyK.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $28e59bb8ab06add2$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $28e59bb8ab06add2$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $6qGSh.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $28e59bb8ab06add2$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $28e59bb8ab06add2$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $3xKQd.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $3xKQd.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $3TBFY.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $28e59bb8ab06add2$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $28e59bb8ab06add2$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $28e59bb8ab06add2$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28e59bb8ab06add2$var$jsonSize(value) {
    return $28e59bb8ab06add2$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $28e59bb8ab06add2$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("apjyK", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $793b69477a43cca5$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $793b69477a43cca5$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("eNTBV", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $ac70c765af467a66$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $ac70c765af467a66$export$25ac7e259a513db4; });

var $jHMUv = parcelRequire("jHMUv");

var $cVl0G = parcelRequire("cVl0G");

var $6qGSh = parcelRequire("6qGSh");

var $foynR = parcelRequire("foynR");

var $8maFY = parcelRequire("8maFY");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $ac70c765af467a66$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $ac70c765af467a66$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $ac70c765af467a66$var$applySpanToEvent(event, span);
    $ac70c765af467a66$var$applyFingerprintToEvent(event, fingerprint);
    $ac70c765af467a66$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $ac70c765af467a66$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $ac70c765af467a66$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $ac70c765af467a66$export$b1a120a2871faa46(data, "extra", extra);
    $ac70c765af467a66$export$b1a120a2871faa46(data, "tags", tags);
    $ac70c765af467a66$export$b1a120a2871faa46(data, "user", user);
    $ac70c765af467a66$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $foynR.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = (0, $jHMUv._)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $ac70c765af467a66$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $foynR.merge)(data[prop], mergeVal, 1);
}
function $ac70c765af467a66$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $6qGSh.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = (0, $jHMUv._)({}, cleanedExtra, event.extra);
    const cleanedTags = (0, $6qGSh.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = (0, $jHMUv._)({}, cleanedTags, event.tags);
    const cleanedUser = (0, $6qGSh.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = (0, $jHMUv._)({}, cleanedUser, event.user);
    const cleanedContexts = (0, $6qGSh.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = (0, $jHMUv._)({}, cleanedContexts, event.contexts);
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $ac70c765af467a66$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $ac70c765af467a66$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $jHMUv._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $ac70c765af467a66$var$applySpanToEvent(event, span) {
    event.contexts = (0, $jHMUv._)({
        trace: (0, $8maFY.spanToTraceContext)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, $jHMUv._)({
        dynamicSamplingContext: (0, $cVl0G.getDynamicSamplingContextFromSpan)(span)
    }, event.sdkProcessingMetadata);
    const rootSpan = (0, $8maFY.getRootSpan)(span);
    const transactionName = (0, $8maFY.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $ac70c765af467a66$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("cVl0G", function(module, exports) {

$parcel$export(module.exports, "freezeDscOnSpan", function () { return $968b1b0aad14f903$export$7398c93e763ca9fd; });
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", function () { return $968b1b0aad14f903$export$89ef1736f08c6b2b; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $968b1b0aad14f903$export$a117f995597e25df; });

var $9MURR = parcelRequire("9MURR");

var $3HlBY = parcelRequire("3HlBY");

var $c29ht = parcelRequire("c29ht");

var $fqiC2 = parcelRequire("fqiC2");

var $6qGSh = parcelRequire("6qGSh");

var $34LSQ = parcelRequire("34LSQ");

var $8maFY = parcelRequire("8maFY");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $968b1b0aad14f903$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $968b1b0aad14f903$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $6qGSh.addNonEnumerableProperty)(spanWithMaybeDsc, $968b1b0aad14f903$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $968b1b0aad14f903$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $6qGSh.dropUndefinedKeys)({
        environment: options.environment || (0, $9MURR.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $968b1b0aad14f903$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $968b1b0aad14f903$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $968b1b0aad14f903$export$a117f995597e25df(span) {
    const client = (0, $3HlBY.getClient)();
    if (!client) return {};
    const rootSpan = (0, $8maFY.getRootSpan)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$968b1b0aad14f903$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $fqiC2.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $968b1b0aad14f903$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $8maFY.spanToJSON)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $34LSQ.hasTracingEnabled)()) dsc.sampled = String((0, $8maFY.spanIsSampled)(rootSpan));
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $968b1b0aad14f903$export$95cf936fdacaff7b(span) {
    const dsc = $968b1b0aad14f903$export$a117f995597e25df(span);
    return (0, $fqiC2.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("c29ht", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $8c2cdef1a8457d28$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $8c2cdef1a8457d28$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $8c2cdef1a8457d28$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $8c2cdef1a8457d28$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function () { return $8c2cdef1a8457d28$export$ba73f34502b7a3b3; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function () { return $8c2cdef1a8457d28$export$f5f95cff026507b5; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function () { return $8c2cdef1a8457d28$export$69cd5c610c7bb96a; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $8c2cdef1a8457d28$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $8c2cdef1a8457d28$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $8c2cdef1a8457d28$export$fea48ba9f4550879; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $8c2cdef1a8457d28$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $8c2cdef1a8457d28$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $8c2cdef1a8457d28$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $8c2cdef1a8457d28$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $8c2cdef1a8457d28$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $8c2cdef1a8457d28$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $8c2cdef1a8457d28$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $8c2cdef1a8457d28$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $8c2cdef1a8457d28$export$1efec95406bbe327 = "sentry.profile_id";
const $8c2cdef1a8457d28$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $8c2cdef1a8457d28$export$b016f89ac1066ec = "cache.hit";
const $8c2cdef1a8457d28$export$3110e4c3f4386399 = "cache.key";
const $8c2cdef1a8457d28$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $8c2cdef1a8457d28$export$be7a251980e7e946 = "http.request.method";
const $8c2cdef1a8457d28$export$25dfd73e0e32c6e1 = "url.full";

});

parcelRegister("fqiC2", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BAGGAGE_KEY_PREFIX", function () { return $b3a7b8c6744f5800$export$6e69537d67fa20f; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $b3a7b8c6744f5800$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $b3a7b8c6744f5800$export$56766feef403f365; });

var $8y3nO = parcelRequire("8y3nO");

var $3xKQd = parcelRequire("3xKQd");

var $4vOpL = parcelRequire("4vOpL");
/**
 * @deprecated Use a `"baggage"` string directly
 */ const $b3a7b8c6744f5800$export$9ca9946bd449ac06 = "baggage";
const $b3a7b8c6744f5800$export$6e69537d67fa20f = "sentry-";
const $b3a7b8c6744f5800$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $b3a7b8c6744f5800$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $b3a7b8c6744f5800$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $b3a7b8c6744f5800$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($b3a7b8c6744f5800$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($b3a7b8c6744f5800$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $b3a7b8c6744f5800$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$b3a7b8c6744f5800$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $b3a7b8c6744f5800$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $b3a7b8c6744f5800$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $3xKQd.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $b3a7b8c6744f5800$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $b3a7b8c6744f5800$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $b3a7b8c6744f5800$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $b3a7b8c6744f5800$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $b3a7b8c6744f5800$export$bdd844ddb2def819) {
            (0, $8y3nO.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});

parcelRegister("34LSQ", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $23d6e382340a8975$export$5008da00b1b6dee6; });

var $3HlBY = parcelRequire("3HlBY");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $23d6e382340a8975$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $3HlBY.getClient)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});

parcelRegister("8maFY", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $6158a8d9c0c25bb9$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $6158a8d9c0c25bb9$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTransactionTraceContext", function () { return $6158a8d9c0c25bb9$export$4c3967a8a2f6bbd6; });
$parcel$export(module.exports, "spanToJSON", function () { return $6158a8d9c0c25bb9$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $6158a8d9c0c25bb9$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $6158a8d9c0c25bb9$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $6158a8d9c0c25bb9$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $6158a8d9c0c25bb9$export$3f7581298f56c6d7; });
$parcel$export(module.exports, "getStatusMessage", function () { return $6158a8d9c0c25bb9$export$e238a77ea3a8cd66; });
$parcel$export(module.exports, "addChildSpanToSpan", function () { return $6158a8d9c0c25bb9$export$81397d924722cc65; });
$parcel$export(module.exports, "removeChildSpanFromSpan", function () { return $6158a8d9c0c25bb9$export$c2a0c9438bb89d91; });
$parcel$export(module.exports, "getSpanDescendants", function () { return $6158a8d9c0c25bb9$export$340c5c8a13ffc680; });
$parcel$export(module.exports, "getRootSpan", function () { return $6158a8d9c0c25bb9$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $6158a8d9c0c25bb9$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $6158a8d9c0c25bb9$export$d11691ff45a3e535; });

var $33sJY = parcelRequire("33sJY");

var $3dQJg = parcelRequire("3dQJg");

var $3HlBY = parcelRequire("3HlBY");

var $k6n49 = parcelRequire("k6n49");

var $c29ht = parcelRequire("c29ht");

var $46vXT = parcelRequire("46vXT");

var $4vOpL = parcelRequire("4vOpL");

var $6qGSh = parcelRequire("6qGSh");

var $01dJv = parcelRequire("01dJv");

var $iBQWV = parcelRequire("iBQWV");

var $fWlRu = parcelRequire("fWlRu");

var $fvhzj = parcelRequire("fvhzj");
// These are aligned with OpenTelemetry trace flags
const $6158a8d9c0c25bb9$export$208d5b368507fb8b = 0x0;
const $6158a8d9c0c25bb9$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $6158a8d9c0c25bb9$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $6158a8d9c0c25bb9$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $6158a8d9c0c25bb9$export$92d8c23565496537(span);
    return (0, $6qGSh.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $6158a8d9c0c25bb9$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $6158a8d9c0c25bb9$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $01dJv.generateSpanId)() : spanId;
    return (0, $6qGSh.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $6158a8d9c0c25bb9$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $6158a8d9c0c25bb9$export$5caecac1caaf3a71(span);
    return (0, $fWlRu.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $6158a8d9c0c25bb9$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $6158a8d9c0c25bb9$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $6158a8d9c0c25bb9$var$ensureTimestampInSeconds(input.getTime());
    return (0, $iBQWV.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $6158a8d9c0c25bb9$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $6158a8d9c0c25bb9$export$92d8c23565496537(span) {
    if ($6158a8d9c0c25bb9$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($6158a8d9c0c25bb9$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $6qGSh.dropUndefinedKeys)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $6158a8d9c0c25bb9$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $6158a8d9c0c25bb9$export$3f7581298f56c6d7(endTime) || undefined,
                status: $6158a8d9c0c25bb9$export$e238a77ea3a8cd66(status),
                op: attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                origin: attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                _metrics_summary: (0, $k6n49.getMetricSummaryJsonForSpan)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $6158a8d9c0c25bb9$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $6158a8d9c0c25bb9$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $6158a8d9c0c25bb9$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $6158a8d9c0c25bb9$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $6158a8d9c0c25bb9$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $46vXT.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $46vXT.SPAN_STATUS_OK)) return "ok";
    return status.message || "unknown_error";
}
const $6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $6158a8d9c0c25bb9$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $6158a8d9c0c25bb9$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$6158a8d9c0c25bb9$var$ROOT_SPAN_FIELD] || span;
    (0, $6qGSh.addNonEnumerableProperty)(childSpan, $6158a8d9c0c25bb9$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD]) span[$6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $6qGSh.addNonEnumerableProperty)(span, $6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $6158a8d9c0c25bb9$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD]) span[$6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $6158a8d9c0c25bb9$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($6158a8d9c0c25bb9$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD] ? Array.from(span[$6158a8d9c0c25bb9$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $6158a8d9c0c25bb9$export$c4c6a79b1260ca1b(span) {
    return span[$6158a8d9c0c25bb9$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $6158a8d9c0c25bb9$export$1be426a8e585c83e() {
    const carrier = (0, $3dQJg.getMainCarrier)();
    const acs = (0, $33sJY.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $fvhzj._getSpanForScope)((0, $3HlBY.getCurrentScope)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $6158a8d9c0c25bb9$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $6158a8d9c0c25bb9$export$1be426a8e585c83e();
    if (span) (0, $k6n49.updateMetricSummaryOnSpan)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $6158a8d9c0c25bb9$export$d11691ff45a3e535() {
    if (!$6158a8d9c0c25bb9$var$hasShownSpanDropWarning) {
        (0, $4vOpL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.");
        });
        $6158a8d9c0c25bb9$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $6158a8d9c0c25bb9$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom",
        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("k6n49", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $ea26429a1b7f543c$export$2e7205e45c58797d; });
$parcel$export(module.exports, "updateMetricSummaryOnSpan", function () { return $ea26429a1b7f543c$export$102c7b059b14a4a; });

var $6qGSh = parcelRequire("6qGSh");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $ea26429a1b7f543c$var$METRICS_SPAN_FIELD = "_sentryMetrics";
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $ea26429a1b7f543c$export$2e7205e45c58797d(span) {
    const storage = span[$ea26429a1b7f543c$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $6qGSh.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $ea26429a1b7f543c$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$ea26429a1b7f543c$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$ea26429a1b7f543c$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}

});

parcelRegister("46vXT", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $2fd084871e34778b$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $2fd084871e34778b$export$58f7963109c806fc; });
$parcel$export(module.exports, "SPAN_STATUS_ERROR", function () { return $2fd084871e34778b$export$f966a0446ece71e; });
$parcel$export(module.exports, "setHttpStatus", function () { return $2fd084871e34778b$export$2ad6630ec8164254; });
const $2fd084871e34778b$export$136e25984ba4a383 = 0;
const $2fd084871e34778b$export$58f7963109c806fc = 1;
const $2fd084871e34778b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $2fd084871e34778b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $2fd084871e34778b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $2fd084871e34778b$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $2fd084871e34778b$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $2fd084871e34778b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $2fd084871e34778b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}

});

parcelRegister("fWlRu", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", function () { return $b9ad3b187f972db1$export$394a210812ba3012; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $b9ad3b187f972db1$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $b9ad3b187f972db1$export$f35d907436da45cf; });

var $fqiC2 = parcelRequire("fqiC2");

var $01dJv = parcelRequire("01dJv");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $b9ad3b187f972db1$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $b9ad3b187f972db1$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($b9ad3b187f972db1$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $b9ad3b187f972db1$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $b9ad3b187f972db1$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $fqiC2.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $01dJv.generateTraceId)(),
        spanId: (0, $01dJv.generateSpanId)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $01dJv.generateSpanId)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $b9ad3b187f972db1$export$f35d907436da45cf(traceId = (0, $01dJv.generateTraceId)(), spanId = (0, $01dJv.generateSpanId)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});






parcelRegister("cn3Tr", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $901aa71bce5bf775$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $901aa71bce5bf775$export$671c7ed8e40a7a57; });

var $klaEy = parcelRequire("klaEy");
const $901aa71bce5bf775$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $901aa71bce5bf775$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $901aa71bce5bf775$var$_getIngestEndpoint(dsn) {
    return `${$901aa71bce5bf775$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $901aa71bce5bf775$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $901aa71bce5bf775$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $901aa71bce5bf775$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$901aa71bce5bf775$var$_getIngestEndpoint(dsn)}?${$901aa71bce5bf775$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $901aa71bce5bf775$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $klaEy.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$901aa71bce5bf775$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $klaEy.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("klaEy", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $ecee0846e2a25c60$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $ecee0846e2a25c60$export$128827c3562ec0cb; });

var $8y3nO = parcelRequire("8y3nO");

var $4vOpL = parcelRequire("4vOpL");
/** Regular expression used to parse a Dsn. */ const $ecee0846e2a25c60$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $ecee0846e2a25c60$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $ecee0846e2a25c60$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $ecee0846e2a25c60$export$b892860177f70a30(str) {
    const match = $ecee0846e2a25c60$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $4vOpL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $ecee0846e2a25c60$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $ecee0846e2a25c60$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $ecee0846e2a25c60$var$validateDsn(dsn) {
    if (!(0, $8y3nO.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $4vOpL.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $4vOpL.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$ecee0846e2a25c60$var$isValidProtocol(protocol)) {
        (0, $4vOpL.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $4vOpL.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $ecee0846e2a25c60$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $ecee0846e2a25c60$export$b892860177f70a30(from) : $ecee0846e2a25c60$var$dsnFromComponents(from);
    if (!components || !$ecee0846e2a25c60$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("8HbQZ", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $654b88c815c9d683$export$1df9218a526d318d; });

var $jHMUv = parcelRequire("jHMUv");

var $4vOpL = parcelRequire("4vOpL");
var $58Rfc = parcelRequire("58Rfc");
var $4EVNg = parcelRequire("4EVNg");
var $kZORs = parcelRequire("kZORs");

var $TSWQd = parcelRequire("TSWQd");

var $gWAAw = parcelRequire("gWAAw");

var $cBmnW = parcelRequire("cBmnW");

var $GQiaa = parcelRequire("GQiaa");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $654b88c815c9d683$export$1df9218a526d318d extends (0, $kZORs.BaseClient) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $gWAAw.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $gWAAw.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $GQiaa.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = (0, $jHMUv._)({
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true
        }, options);
        const sdkSource = (0, $cBmnW.WINDOW).SENTRY_SDK_SOURCE || (0, $58Rfc.getSDKSource)();
        (0, $4EVNg.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $cBmnW.WINDOW).document) (0, $cBmnW.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $cBmnW.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
}

});
parcelRegister("58Rfc", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", function () { return $3be7004eb9a41529$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $3be7004eb9a41529$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $3be7004eb9a41529$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}

});

parcelRegister("4EVNg", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $3647ba76d745e6ff$export$b9f95b027256052c; });

var $k6Tr9 = parcelRequire("k6Tr9");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $3647ba76d745e6ff$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $k6Tr9.SDK_VERSION)
            })),
        version: (0, $k6Tr9.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("kZORs", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $f490f5211d4411e6$export$4f22f74eddb7716a; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $cn3Tr = parcelRequire("cn3Tr");

var $3HlBY = parcelRequire("3HlBY");

var $ilsq0 = parcelRequire("ilsq0");

var $2IrBH = parcelRequire("2IrBH");

var $8aNUP = parcelRequire("8aNUP");

var $2sNxu = parcelRequire("2sNxu");

var $cVl0G = parcelRequire("cVl0G");

var $hkYge = parcelRequire("hkYge");

var $klaEy = parcelRequire("klaEy");

var $ge2tQ = parcelRequire("ge2tQ");

var $gU73f = parcelRequire("gU73f");

var $3xKQd = parcelRequire("3xKQd");

var $4vOpL = parcelRequire("4vOpL");

var $3Swz7 = parcelRequire("3Swz7");

var $3UQvo = parcelRequire("3UQvo");

var $fhppk = parcelRequire("fhppk");

var $izym6 = parcelRequire("izym6");

var $8maFY = parcelRequire("8maFY");
const $f490f5211d4411e6$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $f490f5211d4411e6$export$4f22f74eddb7716a {
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $3Swz7.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $3Swz7.checkOrSetAlreadyCaught)(exception)) {
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log($f490f5211d4411e6$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $jHMUv._)({
            event_id: eventId
        }, hint);
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = (0, $jHMUv._)({
            event_id: (0, $3Swz7.uuid4)()
        }, hint);
        const eventMessage = (0, $3xKQd.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $3xKQd.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $3Swz7.uuid4)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $3Swz7.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log($f490f5211d4411e6$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $jHMUv._)({
            event_id: eventId
        }, hint);
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $2sNxu.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $3UQvo.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $8aNUP.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $8aNUP.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $2IrBH.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $ge2tQ.addItemToEnvelope)(env, (0, $ge2tQ.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $2IrBH.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).error("Error while sending envelope:", reason);
            return reason;
        });
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).error("Transport disabled");
        return (0, $3UQvo.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $8aNUP.setupIntegrations)(this, integrations);
        (0, $8aNUP.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $2sNxu.updateSession)(session, (0, $hYccX._)((0, $jHMUv._)({}, crashed && {
                status: "crashed"
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $3UQvo.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $3HlBY.getCurrentScope)(), isolationScope = (0, $3HlBY.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $izym6.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = (0, $jHMUv._)({
                trace: (0, $3HlBY.getTraceContextFromScope)(currentScope)
            }, evt.contexts);
            const dynamicSamplingContext = (0, $cVl0G.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = (0, $jHMUv._)({
                dynamicSamplingContext: dynamicSamplingContext
            }, evt.sdkProcessingMetadata);
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $ilsq0.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                if (reason instanceof (0, $gU73f.SentryError) && reason.logLevel === "log") (0, $4vOpL.logger).log(reason.message);
                else (0, $4vOpL.logger).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $f490f5211d4411e6$var$isTransactionEvent(event);
        const isError = $f490f5211d4411e6$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $fhppk.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $3UQvo.rejectedSyncPromise)(new (0, $gU73f.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $gU73f.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $f490f5211d4411e6$var$processBeforeSend(this, options, prepared, hint);
            return $f490f5211d4411e6$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $gU73f.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = (0, $hYccX._)((0, $jHMUv._)({}, transactionInfo), {
                    source: source
                });
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $gU73f.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $gU73f.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $hkYge.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $klaEy.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $klaEy.makeDsn)(options.dsn);
        else (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $cn3Tr.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport((0, $hYccX._)((0, $jHMUv._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            "enableTracing",
            "tracesSampleRate",
            "tracesSampler"
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $4vOpL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $f490f5211d4411e6$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $3xKQd.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $3xKQd.isPlainObject)(event) && event !== null) throw new (0, $gU73f.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $gU73f.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $3xKQd.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $gU73f.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $f490f5211d4411e6$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($f490f5211d4411e6$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($f490f5211d4411e6$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $8maFY.showSpanDropWarning)();
                    client.recordDroppedEvent("before_send", "span");
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = (0, $hYccX._)((0, $jHMUv._)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $f490f5211d4411e6$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $f490f5211d4411e6$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

});
parcelRegister("2IrBH", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $1fa51b0972f77adf$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $1fa51b0972f77adf$export$c31057337a18010f; });
$parcel$export(module.exports, "createSpanEnvelope", function () { return $1fa51b0972f77adf$export$19a0081d4b39d77; });

var $jHMUv = parcelRequire("jHMUv");

var $cVl0G = parcelRequire("cVl0G");

var $klaEy = parcelRequire("klaEy");

var $ge2tQ = parcelRequire("ge2tQ");



var $8maFY = parcelRequire("8maFY");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $1fa51b0972f77adf$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $1fa51b0972f77adf$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ge2tQ.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = (0, $jHMUv._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $klaEy.dsnToString)(dsn)
    });
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $ge2tQ.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $1fa51b0972f77adf$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ge2tQ.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $1fa51b0972f77adf$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $ge2tQ.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $ge2tQ.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $1fa51b0972f77adf$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $cVl0G.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = (0, $jHMUv._)({
        sent_at: new Date().toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, $klaEy.dsnToString)(dsn)
    });
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $8maFY.spanToJSON)(span));
        if (!spanJson) (0, $8maFY.showSpanDropWarning)();
        return spanJson;
    } : (span)=>(0, $8maFY.spanToJSON)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $ge2tQ.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $ge2tQ.createEnvelope)(headers, items);
}

});
parcelRegister("ge2tQ", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $bcffe0b48e0fca59$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $bcffe0b48e0fca59$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $bcffe0b48e0fca59$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $bcffe0b48e0fca59$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $bcffe0b48e0fca59$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $bcffe0b48e0fca59$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $bcffe0b48e0fca59$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $bcffe0b48e0fca59$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $bcffe0b48e0fca59$export$92b6093782fe661b; });

var $jHMUv = parcelRequire("jHMUv");

var $klaEy = parcelRequire("klaEy");

var $3vGYX = parcelRequire("3vGYX");

var $6qGSh = parcelRequire("6qGSh");

var $0167p = parcelRequire("0167p");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $bcffe0b48e0fca59$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $bcffe0b48e0fca59$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $bcffe0b48e0fca59$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $bcffe0b48e0fca59$export$604a45d95a155e2b(envelope, types) {
    return $bcffe0b48e0fca59$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $bcffe0b48e0fca59$var$encodeUTF8(input) {
    return (0, $0167p.GLOBAL_OBJ).__SENTRY__ && (0, $0167p.GLOBAL_OBJ).__SENTRY__.encodePolyfill ? (0, $0167p.GLOBAL_OBJ).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $bcffe0b48e0fca59$var$decodeUTF8(input) {
    return (0, $0167p.GLOBAL_OBJ).__SENTRY__ && (0, $0167p.GLOBAL_OBJ).__SENTRY__.decodePolyfill ? (0, $0167p.GLOBAL_OBJ).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $bcffe0b48e0fca59$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $bcffe0b48e0fca59$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $bcffe0b48e0fca59$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $3vGYX.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $bcffe0b48e0fca59$var$concatBuffers(parts);
}
function $bcffe0b48e0fca59$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $bcffe0b48e0fca59$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $bcffe0b48e0fca59$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($bcffe0b48e0fca59$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $bcffe0b48e0fca59$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $bcffe0b48e0fca59$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $bcffe0b48e0fca59$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $6qGSh.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $bcffe0b48e0fca59$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket",
    raw_security: "security"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $bcffe0b48e0fca59$export$b11169581eeaf237(type) {
    return $bcffe0b48e0fca59$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $bcffe0b48e0fca59$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $bcffe0b48e0fca59$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $jHMUv._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $klaEy.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: (0, $6qGSh.dropUndefinedKeys)((0, $jHMUv._)({}, dynamicSamplingContext))
    });
}

});


parcelRegister("hkYge", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $c9f30c76f7538620$export$f3b9ed77c03eeb00; });

var $ge2tQ = parcelRequire("ge2tQ");

var $iBQWV = parcelRequire("iBQWV");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $c9f30c76f7538620$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $iBQWV.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $ge2tQ.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("gU73f", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $c4e7588d185f7e63$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ class $c4e7588d185f7e63$export$5949942ba2a7c0e2 extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}

});

parcelRegister("fhppk", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", function () { return $b1fc26f96ddfb486$export$a5bd2d81656d9546; });

var $ilsq0 = parcelRequire("ilsq0");

var $4vOpL = parcelRequire("4vOpL");
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $b1fc26f96ddfb486$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}

});


parcelRegister("TSWQd", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $0a7fc2b51d1ec8e3$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0a7fc2b51d1ec8e3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("gWAAw", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $c55e71be3774c8d8$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $c55e71be3774c8d8$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $c55e71be3774c8d8$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $c55e71be3774c8d8$export$5425b53185d13d6c; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $3HlBY = parcelRequire("3HlBY");
var $3vGYX = parcelRequire("3vGYX");
var $3xKQd = parcelRequire("3xKQd");
var $3Swz7 = parcelRequire("3Swz7");
var $3UQvo = parcelRequire("3UQvo");
var $6qGSh = parcelRequire("6qGSh");
/**
 * This function creates an exception from a JavaScript Error
 */ function $c55e71be3774c8d8$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $c55e71be3774c8d8$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $c55e71be3774c8d8$export$2e9ae379995d99e3(ex),
        value: $c55e71be3774c8d8$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $c55e71be3774c8d8$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $3HlBY.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $c55e71be3774c8d8$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $3vGYX.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $c55e71be3774c8d8$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $3xKQd.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $c55e71be3774c8d8$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $c55e71be3774c8d8$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $c55e71be3774c8d8$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $c55e71be3774c8d8$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $c55e71be3774c8d8$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $c55e71be3774c8d8$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $c55e71be3774c8d8$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $c55e71be3774c8d8$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $c55e71be3774c8d8$var$getSkipFirstStackStringLines(ex) {
    if (ex && $c55e71be3774c8d8$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $c55e71be3774c8d8$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $c55e71be3774c8d8$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $c55e71be3774c8d8$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $c55e71be3774c8d8$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $c55e71be3774c8d8$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($c55e71be3774c8d8$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $c55e71be3774c8d8$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c55e71be3774c8d8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3Swz7.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3UQvo.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $c55e71be3774c8d8$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c55e71be3774c8d8$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3UQvo.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $c55e71be3774c8d8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $3xKQd.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $c55e71be3774c8d8$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $3xKQd.isDOMError)(exception) || (0, $3xKQd.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $c55e71be3774c8d8$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $3xKQd.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $c55e71be3774c8d8$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $3Swz7.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, $hYccX._)((0, $jHMUv._)({}, event.tags), {
            "DOMException.code": `${domException.code}`
        });
        return event;
    }
    if ((0, $3xKQd.isError)(exception)) // we have a real Error object, do nothing
    return $c55e71be3774c8d8$var$eventFromError(stackParser, exception);
    if ((0, $3xKQd.isPlainObject)(exception) || (0, $3xKQd.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $c55e71be3774c8d8$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $3Swz7.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $c55e71be3774c8d8$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3Swz7.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $3Swz7.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $c55e71be3774c8d8$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $c55e71be3774c8d8$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $3Swz7.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $3xKQd.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $c55e71be3774c8d8$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $6qGSh.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $3xKQd.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $3xKQd.isEvent)(exception)) {
        const className = $c55e71be3774c8d8$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $c55e71be3774c8d8$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $c55e71be3774c8d8$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});

parcelRegister("cBmnW", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $92ca4df5f780cd64$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $92ca4df5f780cd64$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $92ca4df5f780cd64$export$4997ffc0176396a6; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $0167p = parcelRequire("0167p");
var $6qGSh = parcelRequire("6qGSh");
var $3HlBY = parcelRequire("3HlBY");
var $3Swz7 = parcelRequire("3Swz7");
var $kHMxW = parcelRequire("kHMxW");
const $92ca4df5f780cd64$export$56d8a8a25bd48b81 = (0, $0167p.GLOBAL_OBJ);
let $92ca4df5f780cd64$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $92ca4df5f780cd64$export$b79738ab10c590b2() {
    return $92ca4df5f780cd64$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $92ca4df5f780cd64$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $92ca4df5f780cd64$var$ignoreOnError++;
    setTimeout(()=>{
        $92ca4df5f780cd64$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $92ca4df5f780cd64$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $6qGSh.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$92ca4df5f780cd64$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $92ca4df5f780cd64$export$1265a142ff5ba165();
            (0, $3HlBY.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $3Swz7.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $3Swz7.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $hYccX._)((0, $jHMUv._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $kHMxW.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $6qGSh.markFunctionWrapped)(sentryWrapped, fn);
    (0, $6qGSh.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}

});

parcelRegister("GQiaa", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $080c7c734c21c0a6$export$24a4dfcb686ee5bf; });

var $jHMUv = parcelRequire("jHMUv");

var $klaEy = parcelRequire("klaEy");
var $ge2tQ = parcelRequire("ge2tQ");
/**
 * Creates an envelope from a user feedback.
 */ function $080c7c734c21c0a6$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = (0, $jHMUv._)({
        event_id: feedback.event_id,
        sent_at: new Date().toISOString()
    }, metadata && metadata.sdk && {
        sdk: {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        }
    }, !!tunnel && !!dsn && {
        dsn: (0, $klaEy.dsnToString)(dsn)
    });
    const item = $080c7c734c21c0a6$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $ge2tQ.createEnvelope)(headers, [
        item
    ]);
}
function $080c7c734c21c0a6$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("dMmcE", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $a080fb1b589376aa$export$c079d904b326663a; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $idWyH = parcelRequire("idWyH");
var $00147 = parcelRequire("00147");
var $1AbSn = parcelRequire("1AbSn");

var $1nwiY = parcelRequire("1nwiY");
var $3Lp9Q = parcelRequire("3Lp9Q");
var $8aNUP = parcelRequire("8aNUP");
var $3HlBY = parcelRequire("3HlBY");
var $luYok = parcelRequire("luYok");
var $3Swz7 = parcelRequire("3Swz7");
var $4vOpL = parcelRequire("4vOpL");
var $iv9z6 = parcelRequire("iv9z6");
var $hWpjc = parcelRequire("hWpjc");
var $j3Pr8 = parcelRequire("j3Pr8");
var $exjhR = parcelRequire("exjhR");
var $iQ90U = parcelRequire("iQ90U");

var $TSWQd = parcelRequire("TSWQd");

var $cBmnW = parcelRequire("cBmnW");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $a080fb1b589376aa$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $a080fb1b589376aa$var$INTEGRATION_NAME = "Breadcrumbs";
const $a080fb1b589376aa$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = (0, $jHMUv._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $a080fb1b589376aa$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $1nwiY.addConsoleInstrumentationHandler)($a080fb1b589376aa$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $idWyH.addClickKeypressInstrumentationHandler)($a080fb1b589376aa$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $00147.addXhrInstrumentationHandler)($a080fb1b589376aa$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $3Lp9Q.addFetchInstrumentationHandler)($a080fb1b589376aa$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $1AbSn.addHistoryInstrumentationHandler)($a080fb1b589376aa$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $a080fb1b589376aa$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $a080fb1b589376aa$export$c079d904b326663a = (0, $8aNUP.defineIntegration)($a080fb1b589376aa$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $a080fb1b589376aa$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $3HlBY.getClient)() !== client) return;
        (0, $luYok.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $3Swz7.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $a080fb1b589376aa$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $3HlBY.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $a080fb1b589376aa$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$a080fb1b589376aa$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$a080fb1b589376aa$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $a080fb1b589376aa$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $a080fb1b589376aa$var$_isEvent(event) ? event.target : event;
            target = (0, $iv9z6.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $iv9z6.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $luYok.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $a080fb1b589376aa$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $3HlBY.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $hWpjc.severityLevelFromString)(handlerData.level),
            message: (0, $j3Pr8.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $j3Pr8.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $luYok.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $a080fb1b589376aa$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $3HlBY.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $00147.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $exjhR.getBreadcrumbLogLevelFromHttpStatusCode)(status_code);
        (0, $luYok.addBreadcrumb)({
            category: "xhr",
            data: data,
            type: "http",
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $a080fb1b589376aa$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $3HlBY.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $luYok.addBreadcrumb)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = (0, $hYccX._)((0, $jHMUv._)({}, handlerData.fetchData), {
                status_code: response && response.status
            });
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $exjhR.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code);
            (0, $luYok.addBreadcrumb)({
                category: "fetch",
                data: data,
                type: "http",
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $a080fb1b589376aa$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $3HlBY.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $iQ90U.parseUrl)((0, $cBmnW.WINDOW).location.href);
        let parsedFrom = from ? (0, $iQ90U.parseUrl)(from) : undefined;
        const parsedTo = (0, $iQ90U.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $luYok.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $a080fb1b589376aa$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("idWyH", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $d446dd6f74c48453$export$5aeffd3db2cf9df7; });

var $bSLf2 = parcelRequire("bSLf2");
var $6qGSh = parcelRequire("6qGSh");
var $3Swz7 = parcelRequire("3Swz7");

var $2z9m4 = parcelRequire("2z9m4");
const $d446dd6f74c48453$var$DEBOUNCE_DURATION = 1000;
let $d446dd6f74c48453$var$debounceTimerID;
let $d446dd6f74c48453$var$lastCapturedEventType;
let $d446dd6f74c48453$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d446dd6f74c48453$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, $d446dd6f74c48453$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $d446dd6f74c48453$export$3014bbf0af0e1d4a() {
    if (!(0, $2z9m4.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $bSLf2.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $d446dd6f74c48453$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $2z9m4.WINDOW).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $2z9m4.WINDOW).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $2z9m4.WINDOW);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $6qGSh.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $d446dd6f74c48453$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $6qGSh.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $d446dd6f74c48453$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $d446dd6f74c48453$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $d446dd6f74c48453$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $d446dd6f74c48453$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $d446dd6f74c48453$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $d446dd6f74c48453$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($d446dd6f74c48453$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $6qGSh.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $6qGSh.addNonEnumerableProperty)(target, "_sentryId", (0, $3Swz7.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$d446dd6f74c48453$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $d446dd6f74c48453$var$lastCapturedEventType = event.type;
            $d446dd6f74c48453$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($d446dd6f74c48453$var$debounceTimerID);
        $d446dd6f74c48453$var$debounceTimerID = (0, $2z9m4.WINDOW).setTimeout(()=>{
            $d446dd6f74c48453$var$lastCapturedEventTargetId = undefined;
            $d446dd6f74c48453$var$lastCapturedEventType = undefined;
        }, $d446dd6f74c48453$var$DEBOUNCE_DURATION);
    };
}
function $d446dd6f74c48453$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});
parcelRegister("bSLf2", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $8a6962078423e418$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $8a6962078423e418$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $8a6962078423e418$export$b18c893e424d3127; });

var $8y3nO = parcelRequire("8y3nO");

var $4vOpL = parcelRequire("4vOpL");

var $3TBFY = parcelRequire("3TBFY");
// We keep the handlers globally
const $8a6962078423e418$var$handlers = {};
const $8a6962078423e418$var$instrumented = {};
/** Add a handler function. */ function $8a6962078423e418$export$a4e09611e30da72e(type, handler) {
    $8a6962078423e418$var$handlers[type] = $8a6962078423e418$var$handlers[type] || [];
    $8a6962078423e418$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $8a6962078423e418$export$b17eab759a1cb5fe() {
    Object.keys($8a6962078423e418$var$handlers).forEach((key)=>{
        $8a6962078423e418$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $8a6962078423e418$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$8a6962078423e418$var$instrumented[type]) {
        $8a6962078423e418$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $8y3nO.DEBUG_BUILD) && (0, $4vOpL.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $8a6962078423e418$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $8a6962078423e418$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $8y3nO.DEBUG_BUILD) && (0, $4vOpL.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $3TBFY.getFunctionName)(handler)}\nError:`, e);
    }
}

});

parcelRegister("2z9m4", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $1de61b5c6a3de75d$export$56d8a8a25bd48b81; });

var $0167p = parcelRequire("0167p");
const $1de61b5c6a3de75d$export$56d8a8a25bd48b81 = (0, $0167p.GLOBAL_OBJ);

});


parcelRegister("00147", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $0000d3c6ea3cb5cc$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $0000d3c6ea3cb5cc$export$26ace48dd54c9aea; });

var $bSLf2 = parcelRequire("bSLf2");
var $iBQWV = parcelRequire("iBQWV");
var $3xKQd = parcelRequire("3xKQd");

var $2z9m4 = parcelRequire("2z9m4");
const $0000d3c6ea3cb5cc$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0000d3c6ea3cb5cc$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, $0000d3c6ea3cb5cc$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0000d3c6ea3cb5cc$export$c67d533bf77cbf54() {
    if (!(0, $2z9m4.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $iBQWV.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $3xKQd.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $0000d3c6ea3cb5cc$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$0000d3c6ea3cb5cc$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$0000d3c6ea3cb5cc$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $iBQWV.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $bSLf2.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$0000d3c6ea3cb5cc$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $3xKQd.isString)(header) && (0, $3xKQd.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$0000d3c6ea3cb5cc$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $iBQWV.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $bSLf2.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $0000d3c6ea3cb5cc$var$parseUrl(url) {
    if ((0, $3xKQd.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("1AbSn", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $12725d8c30d2c107$export$3f18c56c58114e75; });

var $bSLf2 = parcelRequire("bSLf2");
var $3rU1g = parcelRequire("3rU1g");
var $6qGSh = parcelRequire("6qGSh");

var $2z9m4 = parcelRequire("2z9m4");
let $12725d8c30d2c107$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $12725d8c30d2c107$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, $12725d8c30d2c107$var$instrumentHistory);
}
function $12725d8c30d2c107$var$instrumentHistory() {
    if (!(0, $3rU1g.supportsHistory)()) return;
    const oldOnPopState = (0, $2z9m4.WINDOW).onpopstate;
    (0, $2z9m4.WINDOW).onpopstate = function(...args) {
        const to = (0, $2z9m4.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $12725d8c30d2c107$var$lastHref;
        $12725d8c30d2c107$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $bSLf2.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $12725d8c30d2c107$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $12725d8c30d2c107$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $bSLf2.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $6qGSh.fill)((0, $2z9m4.WINDOW).history, "pushState", historyReplacementFunction);
    (0, $6qGSh.fill)((0, $2z9m4.WINDOW).history, "replaceState", historyReplacementFunction);
}

});
parcelRegister("3rU1g", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $282f58ffa71b9873$export$67fc34576016d6ec; });

var $0167p = parcelRequire("0167p");
// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $282f58ffa71b9873$var$WINDOW = (0, $0167p.GLOBAL_OBJ);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $282f58ffa71b9873$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $282f58ffa71b9873$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = "history" in $282f58ffa71b9873$var$WINDOW && !!$282f58ffa71b9873$var$WINDOW.history.pushState && !!$282f58ffa71b9873$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("1nwiY", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $1010ff8612049276$export$1d6e0d073f9e6723; });

var $4vOpL = parcelRequire("4vOpL");

var $6qGSh = parcelRequire("6qGSh");

var $0167p = parcelRequire("0167p");

var $bSLf2 = parcelRequire("bSLf2");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1010ff8612049276$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, $1010ff8612049276$var$instrumentConsole);
}
function $1010ff8612049276$var$instrumentConsole() {
    if (!("console" in (0, $0167p.GLOBAL_OBJ))) return;
    (0, $4vOpL.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $0167p.GLOBAL_OBJ).console)) return;
        (0, $6qGSh.fill)((0, $0167p.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $4vOpL.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $bSLf2.triggerHandlers)("console", handlerData);
                const log = (0, $4vOpL.originalConsoleMethods)[level];
                log && log.apply((0, $0167p.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("3Lp9Q", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $2bd946b4cbc19966$export$f75d3c772c923df0; });
$parcel$export(module.exports, "addFetchEndInstrumentationHandler", function () { return $2bd946b4cbc19966$export$1a79663eb318fe6a; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $3xKQd = parcelRequire("3xKQd");

var $6qGSh = parcelRequire("6qGSh");

var $lwEDW = parcelRequire("lwEDW");

var $iBQWV = parcelRequire("iBQWV");

var $0167p = parcelRequire("0167p");

var $bSLf2 = parcelRequire("bSLf2");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2bd946b4cbc19966$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, ()=>$2bd946b4cbc19966$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $2bd946b4cbc19966$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, ()=>$2bd946b4cbc19966$var$instrumentFetch($2bd946b4cbc19966$var$streamHandler));
}
function $2bd946b4cbc19966$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $lwEDW.supportsNativeFetch)()) return;
    (0, $6qGSh.fill)((0, $0167p.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $2bd946b4cbc19966$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $iBQWV.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $bSLf2.triggerHandlers)("fetch", (0, $jHMUv._)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $0167p.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $bSLf2.triggerHandlers)("fetch", (0, $hYccX._)((0, $jHMUv._)({}, handlerData), {
                    endTimestamp: (0, $iBQWV.timestampInSeconds)() * 1000,
                    response: response
                }));
                return response;
            }, (error)=>{
                (0, $bSLf2.triggerHandlers)("fetch", (0, $hYccX._)((0, $jHMUv._)({}, handlerData), {
                    endTimestamp: (0, $iBQWV.timestampInSeconds)() * 1000,
                    error: error
                }));
                if ((0, $3xKQd.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $6qGSh.addNonEnumerableProperty)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $2bd946b4cbc19966$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $2bd946b4cbc19966$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $2bd946b4cbc19966$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $bSLf2.triggerHandlers)("fetch-body-resolved", {
            endTimestamp: (0, $iBQWV.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $2bd946b4cbc19966$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $2bd946b4cbc19966$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($2bd946b4cbc19966$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $2bd946b4cbc19966$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $2bd946b4cbc19966$var$getUrlFromResource(url),
            method: $2bd946b4cbc19966$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $2bd946b4cbc19966$var$getUrlFromResource(arg),
        method: $2bd946b4cbc19966$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});

parcelRegister("luYok", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", function () { return $fa6b3ecdec97bb20$export$efda9a273d7a036d; });

var $jHMUv = parcelRequire("jHMUv");

var $3HlBY = parcelRequire("3HlBY");

var $4vOpL = parcelRequire("4vOpL");

var $iBQWV = parcelRequire("iBQWV");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $fa6b3ecdec97bb20$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $fa6b3ecdec97bb20$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $3HlBY.getClient)();
    const isolationScope = (0, $3HlBY.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $fa6b3ecdec97bb20$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $iBQWV.dateTimestampInSeconds)();
    const mergedBreadcrumb = (0, $jHMUv._)({
        timestamp: timestamp
    }, breadcrumb);
    const finalBreadcrumb = beforeBreadcrumb ? (0, $4vOpL.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});

parcelRegister("hWpjc", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $d0fb7c3f2304a0e5$export$d771ef054122c30a; });
/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $d0fb7c3f2304a0e5$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $d0fb7c3f2304a0e5$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}

});

parcelRegister("exjhR", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", function () { return $a9531bc4b59cad7c$export$b8cfcc4175694bcc; });
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $a9531bc4b59cad7c$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}

});

parcelRegister("iQ90U", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $db741341945be123$export$7a5253c0f62e0150; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $db741341945be123$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $db741341945be123$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $db741341945be123$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $db741341945be123$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});


parcelRegister("6ESHT", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $4d90ea303508b5c5$export$59bfe9f1c76150e; });

var $jHMUv = parcelRequire("jHMUv");

var $6qGSh = parcelRequire("6qGSh");
var $8aNUP = parcelRequire("8aNUP");
var $3TBFY = parcelRequire("3TBFY");

var $cBmnW = parcelRequire("cBmnW");
const $4d90ea303508b5c5$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $4d90ea303508b5c5$var$INTEGRATION_NAME = "BrowserApiErrors";
const $4d90ea303508b5c5$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = (0, $jHMUv._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true
    }, options);
    return {
        name: $4d90ea303508b5c5$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $6qGSh.fill)((0, $cBmnW.WINDOW), "setTimeout", $4d90ea303508b5c5$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $6qGSh.fill)((0, $cBmnW.WINDOW), "setInterval", $4d90ea303508b5c5$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $6qGSh.fill)((0, $cBmnW.WINDOW), "requestAnimationFrame", $4d90ea303508b5c5$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $cBmnW.WINDOW)) (0, $6qGSh.fill)(XMLHttpRequest.prototype, "send", $4d90ea303508b5c5$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4d90ea303508b5c5$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4d90ea303508b5c5$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4d90ea303508b5c5$export$59bfe9f1c76150e = (0, $8aNUP.defineIntegration)($4d90ea303508b5c5$var$_browserApiErrorsIntegration);
function $4d90ea303508b5c5$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $cBmnW.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $3TBFY.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
function $4d90ea303508b5c5$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $cBmnW.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $3TBFY.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $4d90ea303508b5c5$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $6qGSh.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $3TBFY.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $6qGSh.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $3TBFY.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $cBmnW.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4d90ea303508b5c5$var$_wrapEventTarget(target) {
    const globalObject = (0, $cBmnW.WINDOW);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $6qGSh.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4d90ea303508b5c5$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $cBmnW.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $3TBFY.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $cBmnW.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $3TBFY.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $6qGSh.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4d90ea303508b5c5$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}

});

parcelRegister("ck2N4", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", function () { return $8f89846c9be8ecf5$export$1baa7880e357371c; });

var $1AbSn = parcelRequire("1AbSn");

var $8aNUP = parcelRequire("8aNUP");
var $4vOpL = parcelRequire("4vOpL");
var $kHMxW = parcelRequire("kHMxW");

var $TSWQd = parcelRequire("TSWQd");

var $cBmnW = parcelRequire("cBmnW");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8f89846c9be8ecf5$export$1baa7880e357371c = (0, $8aNUP.defineIntegration)(()=>{
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $cBmnW.WINDOW).document === "undefined") {
                (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $kHMxW.startSession)({
                ignoreDuration: true
            });
            (0, $kHMxW.captureSession)();
            // We want to create a session for every navigation as well
            (0, $1AbSn.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $kHMxW.startSession)({
                        ignoreDuration: true
                    });
                    (0, $kHMxW.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("hMCun", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $cf24c675d583e8d1$export$66acc70e8cf2b71a; });

var $jHMUv = parcelRequire("jHMUv");

var $8aNUP = parcelRequire("8aNUP");
var $lebw5 = parcelRequire("lebw5");
var $3HlBY = parcelRequire("3HlBY");
var $kHMxW = parcelRequire("kHMxW");
var $bicNP = parcelRequire("bicNP");
var $3xKQd = parcelRequire("3xKQd");
var $iv9z6 = parcelRequire("iv9z6");
var $3TBFY = parcelRequire("3TBFY");
var $4vOpL = parcelRequire("4vOpL");

var $TSWQd = parcelRequire("TSWQd");

var $gWAAw = parcelRequire("gWAAw");

var $cBmnW = parcelRequire("cBmnW");
const $cf24c675d583e8d1$var$INTEGRATION_NAME = "GlobalHandlers";
const $cf24c675d583e8d1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = (0, $jHMUv._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $cf24c675d583e8d1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $cf24c675d583e8d1$var$_installGlobalOnErrorHandler(client);
                $cf24c675d583e8d1$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $cf24c675d583e8d1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $cf24c675d583e8d1$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $cf24c675d583e8d1$export$66acc70e8cf2b71a = (0, $8aNUP.defineIntegration)($cf24c675d583e8d1$var$_globalHandlersIntegration);
function $cf24c675d583e8d1$var$_installGlobalOnErrorHandler(client) {
    (0, $lebw5.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $cf24c675d583e8d1$var$getOptions();
        if ((0, $3HlBY.getClient)() !== client || (0, $cBmnW.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $cf24c675d583e8d1$var$_enhanceEventWithInitialFrame((0, $gWAAw.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $kHMxW.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $cf24c675d583e8d1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $bicNP.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $cf24c675d583e8d1$var$getOptions();
        if ((0, $3HlBY.getClient)() !== client || (0, $cBmnW.shouldIgnoreOnError)()) return;
        const error = $cf24c675d583e8d1$var$_getUnhandledRejectionError(e);
        const event = (0, $3xKQd.isPrimitive)(error) ? $cf24c675d583e8d1$var$_eventFromRejectionWithPrimitive(error) : (0, $gWAAw.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $kHMxW.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $cf24c675d583e8d1$var$_getUnhandledRejectionError(error) {
    if ((0, $3xKQd.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $cf24c675d583e8d1$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $cf24c675d583e8d1$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $3xKQd.isString)(url) && url.length > 0 ? url : (0, $iv9z6.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $3TBFY.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $cf24c675d583e8d1$var$globalHandlerLog(type) {
    (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).log(`Global Handler attached: ${type}`);
}
function $cf24c675d583e8d1$var$getOptions() {
    const client = (0, $3HlBY.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("lebw5", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $03fcf71365c896a9$export$55b5c3ba2194f0c6; });

var $0167p = parcelRequire("0167p");

var $bSLf2 = parcelRequire("bSLf2");
let $03fcf71365c896a9$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $03fcf71365c896a9$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, $03fcf71365c896a9$var$instrumentError);
}
function $03fcf71365c896a9$var$instrumentError() {
    $03fcf71365c896a9$var$_oldOnErrorHandler = (0, $0167p.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $0167p.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $bSLf2.triggerHandlers)("error", handlerData);
        if ($03fcf71365c896a9$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $03fcf71365c896a9$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $0167p.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("bicNP", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $838b4e78d25bf155$export$8bf4fc6858821a4e; });

var $0167p = parcelRequire("0167p");

var $bSLf2 = parcelRequire("bSLf2");
let $838b4e78d25bf155$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $838b4e78d25bf155$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $bSLf2.addHandler)(type, handler);
    (0, $bSLf2.maybeInstrument)(type, $838b4e78d25bf155$var$instrumentUnhandledRejection);
}
function $838b4e78d25bf155$var$instrumentUnhandledRejection() {
    $838b4e78d25bf155$var$_oldOnUnhandledRejectionHandler = (0, $0167p.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $0167p.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $bSLf2.triggerHandlers)("unhandledrejection", handlerData);
        if ($838b4e78d25bf155$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $838b4e78d25bf155$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $0167p.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("57j5s", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $3b9c697d0d6ae046$export$1378794447170364; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $8aNUP = parcelRequire("8aNUP");

var $cBmnW = parcelRequire("cBmnW");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $3b9c697d0d6ae046$export$1378794447170364 = (0, $8aNUP.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $cBmnW.WINDOW).navigator && !(0, $cBmnW.WINDOW).location && !(0, $cBmnW.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $cBmnW.WINDOW).location && (0, $cBmnW.WINDOW).location.href;
            const { referrer: referrer } = (0, $cBmnW.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $cBmnW.WINDOW).navigator || {};
            const headers = (0, $jHMUv._)({}, event.request && event.request.headers, referrer && {
                Referer: referrer
            }, userAgent && {
                "User-Agent": userAgent
            });
            const request = (0, $hYccX._)((0, $jHMUv._)({}, event.request, url && {
                url: url
            }), {
                headers: headers
            });
            event.request = request;
        }
    };
});

});

parcelRegister("bPeEv", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $89bfd2c7962d6367$export$ebabb00eb7f3a395; });

var $9x1Mq = parcelRequire("9x1Mq");
var $8aNUP = parcelRequire("8aNUP");

var $gWAAw = parcelRequire("gWAAw");
const $89bfd2c7962d6367$var$DEFAULT_KEY = "cause";
const $89bfd2c7962d6367$var$DEFAULT_LIMIT = 5;
const $89bfd2c7962d6367$var$INTEGRATION_NAME = "LinkedErrors";
const $89bfd2c7962d6367$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $89bfd2c7962d6367$var$DEFAULT_LIMIT;
    const key = options.key || $89bfd2c7962d6367$var$DEFAULT_KEY;
    return {
        name: $89bfd2c7962d6367$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9x1Mq.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $gWAAw.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $89bfd2c7962d6367$export$ebabb00eb7f3a395 = (0, $8aNUP.defineIntegration)($89bfd2c7962d6367$var$_linkedErrorsIntegration);

});
parcelRegister("9x1Mq", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $6f08939a029bd21a$export$b91c38ed7d8ae9b2; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $3xKQd = parcelRequire("3xKQd");

var $j3Pr8 = parcelRequire("j3Pr8");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $6f08939a029bd21a$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $3xKQd.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $6f08939a029bd21a$var$truncateAggregateExceptions($6f08939a029bd21a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $6f08939a029bd21a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $3xKQd.isInstanceOf)(error[key], Error)) {
        $6f08939a029bd21a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $6f08939a029bd21a$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $6f08939a029bd21a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $3xKQd.isInstanceOf)(childError, Error)) {
            $6f08939a029bd21a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $6f08939a029bd21a$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $6f08939a029bd21a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $6f08939a029bd21a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0, $hYccX._)((0, $jHMUv._)({}, exception.mechanism, exception.type === "AggregateError" && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function $6f08939a029bd21a$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0, $hYccX._)((0, $jHMUv._)({}, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $6f08939a029bd21a$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $j3Pr8.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("7F7Fy", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $59424faf1ead7389$export$2b2b997d81bf3907; });

var $3TBFY = parcelRequire("3TBFY");
// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $59424faf1ead7389$var$OPERA10_PRIORITY = 10;
const $59424faf1ead7389$var$OPERA11_PRIORITY = 20;
const $59424faf1ead7389$var$CHROME_PRIORITY = 30;
const $59424faf1ead7389$var$WINJS_PRIORITY = 40;
const $59424faf1ead7389$var$GECKO_PRIORITY = 50;
function $59424faf1ead7389$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $3TBFY.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $59424faf1ead7389$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $59424faf1ead7389$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $59424faf1ead7389$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $59424faf1ead7389$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $59424faf1ead7389$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $59424faf1ead7389$var$createFrame(filename, (0, $3TBFY.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $59424faf1ead7389$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $59424faf1ead7389$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $59424faf1ead7389$var$extractSafariExtensionDetails(parts[1] || (0, $3TBFY.UNKNOWN_FUNCTION), parts[2]);
        return $59424faf1ead7389$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $59424faf1ead7389$export$263a749fff749872 = [
    $59424faf1ead7389$var$CHROME_PRIORITY,
    $59424faf1ead7389$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $59424faf1ead7389$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $59424faf1ead7389$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $59424faf1ead7389$var$gecko = (line)=>{
    const parts = $59424faf1ead7389$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $59424faf1ead7389$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $3TBFY.UNKNOWN_FUNCTION);
        [func, filename] = $59424faf1ead7389$var$extractSafariExtensionDetails(func, filename);
        return $59424faf1ead7389$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $59424faf1ead7389$export$cdba47a5dd2804d = [
    $59424faf1ead7389$var$GECKO_PRIORITY,
    $59424faf1ead7389$var$gecko
];
const $59424faf1ead7389$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $59424faf1ead7389$var$winjs = (line)=>{
    const parts = $59424faf1ead7389$var$winjsRegex.exec(line);
    return parts ? $59424faf1ead7389$var$createFrame(parts[2], parts[1] || (0, $3TBFY.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $59424faf1ead7389$export$179460296da408e8 = [
    $59424faf1ead7389$var$WINJS_PRIORITY,
    $59424faf1ead7389$var$winjs
];
const $59424faf1ead7389$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $59424faf1ead7389$var$opera10 = (line)=>{
    const parts = $59424faf1ead7389$var$opera10Regex.exec(line);
    return parts ? $59424faf1ead7389$var$createFrame(parts[2], parts[3] || (0, $3TBFY.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $59424faf1ead7389$export$f892b52c880ffc7a = [
    $59424faf1ead7389$var$OPERA10_PRIORITY,
    $59424faf1ead7389$var$opera10
];
const $59424faf1ead7389$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $59424faf1ead7389$var$opera11 = (line)=>{
    const parts = $59424faf1ead7389$var$opera11Regex.exec(line);
    return parts ? $59424faf1ead7389$var$createFrame(parts[5], parts[3] || parts[4] || (0, $3TBFY.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $59424faf1ead7389$export$af11af13f09fb0dc = [
    $59424faf1ead7389$var$OPERA11_PRIORITY,
    $59424faf1ead7389$var$opera11
];
const $59424faf1ead7389$export$7197c0fe6554c079 = [
    $59424faf1ead7389$export$263a749fff749872,
    $59424faf1ead7389$export$cdba47a5dd2804d
];
const $59424faf1ead7389$export$2b2b997d81bf3907 = (0, $3TBFY.createStackParser)(...$59424faf1ead7389$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $59424faf1ead7389$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $3TBFY.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("8aOJO", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $5f369d64ca7f69f2$export$b2311068c46d7cc8; });

var $jHMUv = parcelRequire("jHMUv");

var $a82b7 = parcelRequire("a82b7");

var $3UQvo = parcelRequire("3UQvo");
var $gEzfK = parcelRequire("gEzfK");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $5f369d64ca7f69f2$export$b2311068c46d7cc8(options, nativeFetch = (0, $a82b7.getNativeImplementation)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = (0, $jHMUv._)({
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        if (!nativeFetch) {
            (0, $a82b7.clearCachedImplementation)("fetch");
            return (0, $3UQvo.rejectedSyncPromise)("No fetch implementation available");
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $a82b7.clearCachedImplementation)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $3UQvo.rejectedSyncPromise)(e);
        }
    }
    return (0, $gEzfK.createTransport)(options, makeRequest);
}

});
parcelRegister("a82b7", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", function () { return $01e72ab2d222b611$export$e464f4a514ac28a8; });
$parcel$export(module.exports, "clearCachedImplementation", function () { return $01e72ab2d222b611$export$8aa36702e8c8978; });

var $lwEDW = parcelRequire("lwEDW");
var $4vOpL = parcelRequire("4vOpL");

var $44HcR = parcelRequire("44HcR");

var $2z9m4 = parcelRequire("2z9m4");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $01e72ab2d222b611$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $01e72ab2d222b611$export$e464f4a514ac28a8(name) {
    const cached = $01e72ab2d222b611$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $2z9m4.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $lwEDW.isNativeFunction)(impl)) return $01e72ab2d222b611$var$cachedImplementations[name] = impl.bind((0, $2z9m4.WINDOW));
    const document = (0, $2z9m4.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $44HcR.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $01e72ab2d222b611$var$cachedImplementations[name] = impl.bind((0, $2z9m4.WINDOW));
}
/** Clear a cached implementation. */ function $01e72ab2d222b611$export$8aa36702e8c8978(name) {
    $01e72ab2d222b611$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $01e72ab2d222b611$export$e7aa7bc5c1b3cfb3(...rest) {
    return $01e72ab2d222b611$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $01e72ab2d222b611$export$831dc9f2ab0a617b(...rest) {
    return $01e72ab2d222b611$export$e464f4a514ac28a8("setTimeout")(...rest);
}

});
parcelRegister("44HcR", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $2f790d0bfebe295b$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2f790d0bfebe295b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("gEzfK", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $c1fbba41086c1dc9$export$d09f50d9ab7f7b69; });

var $ilsq0 = parcelRequire("ilsq0");

var $ge2tQ = parcelRequire("ge2tQ");

var $gU73f = parcelRequire("gU73f");

var $4vOpL = parcelRequire("4vOpL");

var $6jlTN = parcelRequire("6jlTN");

var $c5hSh = parcelRequire("c5hSh");

var $3UQvo = parcelRequire("3UQvo");
const $c1fbba41086c1dc9$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $c1fbba41086c1dc9$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $6jlTN.makePromiseBuffer)(options.bufferSize || $c1fbba41086c1dc9$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $ge2tQ.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $ge2tQ.envelopeItemTypeToDataCategory)(type);
            if ((0, $c5hSh.isRateLimited)(rateLimits, dataCategory)) {
                const event = $c1fbba41086c1dc9$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $3UQvo.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $ge2tQ.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $ge2tQ.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $c1fbba41086c1dc9$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $ge2tQ.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $ge2tQ.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $c5hSh.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $gU73f.SentryError)) {
                (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $3UQvo.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $c1fbba41086c1dc9$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("6jlTN", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $498581181652ca2f$export$85a4f67f852183e6; });

var $gU73f = parcelRequire("gU73f");

var $3UQvo = parcelRequire("3UQvo");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $498581181652ca2f$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $3UQvo.rejectedSyncPromise)(new (0, $gU73f.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $3UQvo.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $3UQvo.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("c5hSh", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $8cc3d12c574cdef3$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $8cc3d12c574cdef3$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var $jHMUv = parcelRequire("jHMUv");
const $8cc3d12c574cdef3$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $8cc3d12c574cdef3$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $8cc3d12c574cdef3$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $8cc3d12c574cdef3$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $8cc3d12c574cdef3$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $8cc3d12c574cdef3$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $8cc3d12c574cdef3$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = (0, $jHMUv._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $8cc3d12c574cdef3$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});




parcelRegister("61mwv", function(module, exports) {

$parcel$export(module.exports, "browserTracingIntegration", function () { return $46244ebcf06291c8$export$b4109253475213e9; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $32hmn = parcelRequire("32hmn");
var $hSxVX = parcelRequire("hSxVX");
var $1AbSn = parcelRequire("1AbSn");

var $bRl6w = parcelRequire("bRl6w");
var $iy15R = parcelRequire("iy15R");
var $0167p = parcelRequire("0167p");
var $c29ht = parcelRequire("c29ht");
var $8maFY = parcelRequire("8maFY");
var $4vOpL = parcelRequire("4vOpL");
var $3HlBY = parcelRequire("3HlBY");
var $fWlRu = parcelRequire("fWlRu");
var $cVl0G = parcelRequire("cVl0G");
var $iBQWV = parcelRequire("iBQWV");
var $01dJv = parcelRequire("01dJv");
var $iv9z6 = parcelRequire("iv9z6");

var $TSWQd = parcelRequire("TSWQd");

var $cBmnW = parcelRequire("cBmnW");

var $cAnkP = parcelRequire("cAnkP");

var $kg7Ib = parcelRequire("kg7Ib");
/* eslint-disable max-lines */ const $46244ebcf06291c8$export$bbd2089f30bd3708 = "BrowserTracing";
const $46244ebcf06291c8$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $jHMUv._)((0, $hYccX._)((0, $jHMUv._)({}, (0, $bRl6w.TRACING_DEFAULTS)), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {}
}), (0, $kg7Ib.defaultRequestInstrumentationOptions));
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $46244ebcf06291c8$export$b4109253475213e9 = (_options = {})=>{
    (0, $iy15R.registerSpanErrorInstrumentation)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = (0, $jHMUv._)({}, $46244ebcf06291c8$var$DEFAULT_BROWSER_TRACING_OPTIONS, _options);
    const _collectWebVitals = (0, $32hmn.startTrackingWebVitals)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $hSxVX.startTrackingINP)();
    if (enableLongAnimationFrame && (0, $0167p.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame")) (0, $32hmn.startTrackingLongAnimationFrames)();
    else if (enableLongTask) (0, $32hmn.startTrackingLongTasks)();
    if (enableInteractions) (0, $32hmn.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === "pageload";
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $bRl6w.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $32hmn.addPerformanceEntries)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                "interactive",
                "complete"
            ].includes((0, $cBmnW.WINDOW).document.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadTransaction && (0, $cBmnW.WINDOW).document) {
            (0, $cBmnW.WINDOW).document.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $46244ebcf06291c8$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $cBmnW.WINDOW).location && (0, $cBmnW.WINDOW).location.href;
            function maybeEndActiveSpan() {
                if (activeSpan && !(0, $8maFY.spanToJSON)(activeSpan).timestamp) {
                    (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).log(`[Tracing] Finishing current active span with op: ${(0, $8maFY.spanToJSON)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions)=>{
                if ((0, $3HlBY.getClient)() !== client) return;
                maybeEndActiveSpan();
                activeSpan = _createRouteSpan(client, (0, $jHMUv._)({
                    op: "navigation"
                }, startSpanOptions));
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $3HlBY.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $46244ebcf06291c8$export$f147b32b03c9cf11("sentry-trace");
                const baggage = traceOptions.baggage || $46244ebcf06291c8$export$f147b32b03c9cf11("baggage");
                const propagationContext = (0, $fWlRu.propagationContextFromHeaders)(sentryTrace, baggage);
                (0, $3HlBY.getCurrentScope)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, (0, $jHMUv._)({
                    op: "pageload"
                }, startSpanOptions));
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on("spanEnd", (span)=>{
                const op = (0, $8maFY.spanToJSON)(span).op;
                if (span !== (0, $8maFY.getRootSpan)(span) || op !== "navigation" && op !== "pageload") return;
                const scope = (0, $3HlBY.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext((0, $hYccX._)((0, $jHMUv._)({}, oldPropagationContext), {
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $8maFY.spanIsSampled)(span),
                    dsc: oldPropagationContext.dsc || (0, $cVl0G.getDynamicSamplingContextFromSpan)(span)
                }));
            });
            if ((0, $cBmnW.WINDOW).location) {
                if (instrumentPageLoad) $46244ebcf06291c8$export$aa44a07f82af519f(client, {
                    name: (0, $cBmnW.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $iBQWV.browserPerformanceTimeOrigin) ? (0, $iBQWV.browserPerformanceTimeOrigin) / 1000 : undefined,
                    attributes: {
                        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                    }
                });
                if (instrumentNavigation) (0, $1AbSn.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $46244ebcf06291c8$export$7d159749bd9969ad(client, {
                            name: (0, $cBmnW.WINDOW).location.pathname,
                            attributes: {
                                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $cAnkP.registerBackgroundTabDetection)();
            if (enableInteractions) $46244ebcf06291c8$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $hSxVX.registerInpInteractionListener)();
            (0, $kg7Ib.instrumentOutgoingRequests)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $46244ebcf06291c8$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $3HlBY.getCurrentScope)().setTransactionName(spanOptions.name);
    const span = (0, $8maFY.getActiveSpan)();
    const op = span && (0, $8maFY.spanToJSON)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $46244ebcf06291c8$export$7d159749bd9969ad(client, spanOptions) {
    (0, $3HlBY.getIsolationScope)().setPropagationContext({
        traceId: (0, $01dJv.generateTraceId)()
    });
    (0, $3HlBY.getCurrentScope)().setPropagationContext({
        traceId: (0, $01dJv.generateTraceId)()
    });
    client.emit("startNavigationSpan", spanOptions);
    (0, $3HlBY.getCurrentScope)().setTransactionName(spanOptions.name);
    const span = (0, $8maFY.getActiveSpan)();
    const op = span && (0, $8maFY.spanToJSON)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $46244ebcf06291c8$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    // eslint-disable-next-line deprecation/deprecation
    const metaTag = (0, $iv9z6.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $46244ebcf06291c8$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeSpan = (0, $8maFY.getActiveSpan)();
        const rootSpan = activeSpan && (0, $8maFY.getRootSpan)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $8maFY.spanToJSON)(rootSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $bRl6w.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $cBmnW.WINDOW).document) addEventListener("click", registerInteractionTransaction, {
        once: false,
        capture: true
    });
}

});
parcelRegister("32hmn", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", function () { return $235f065844cb7e84$export$7c69f0412d101b88; });
$parcel$export(module.exports, "startTrackingLongTasks", function () { return $235f065844cb7e84$export$f396d19077034ad2; });
$parcel$export(module.exports, "startTrackingLongAnimationFrames", function () { return $235f065844cb7e84$export$5b823ab2ccbc801d; });
$parcel$export(module.exports, "startTrackingInteractions", function () { return $235f065844cb7e84$export$e27543e0976315e4; });
$parcel$export(module.exports, "addPerformanceEntries", function () { return $235f065844cb7e84$export$5f8fa6b3467a7443; });

var $iBQWV = parcelRequire("iBQWV");
var $8maFY = parcelRequire("8maFY");
var $c29ht = parcelRequire("c29ht");
var $iv9z6 = parcelRequire("iv9z6");
var $jljxN = parcelRequire("jljxN");
var $iQ90U = parcelRequire("iQ90U");

var $2z9m4 = parcelRequire("2z9m4");

var $2Mebr = parcelRequire("2Mebr");

var $4VX7K = parcelRequire("4VX7K");

var $OEeFi = parcelRequire("OEeFi");

var $5OMWF = parcelRequire("5OMWF");

var $dlxhi = parcelRequire("dlxhi");

var $gt3y1 = parcelRequire("gt3y1");
const $235f065844cb7e84$var$MAX_INT_AS_BYTES = 2147483647;
let $235f065844cb7e84$var$_performanceCursor = 0;
let $235f065844cb7e84$var$_measurements = {};
let $235f065844cb7e84$var$_lcpEntry;
let $235f065844cb7e84$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $235f065844cb7e84$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $OEeFi.getBrowserPerformanceAPI)();
    if (performance && (0, $iBQWV.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $2z9m4.WINDOW).performance.mark("sentry-tracing-init");
        const fidCleanupCallback = $235f065844cb7e84$var$_trackFID();
        const lcpCleanupCallback = $235f065844cb7e84$var$_trackLCP();
        const ttfbCleanupCallback = $235f065844cb7e84$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $2Mebr.trackClsAsStandaloneSpan)() : $235f065844cb7e84$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $235f065844cb7e84$export$f396d19077034ad2() {
    (0, $4VX7K.addPerformanceInstrumentationHandler)("longtask", ({ entries: entries })=>{
        const parent = (0, $8maFY.getActiveSpan)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $8maFY.spanToJSON)(parent);
        for (const entry of entries){
            const startTime = (0, $OEeFi.msToSec)((0, $iBQWV.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = (0, $OEeFi.msToSec)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $OEeFi.startAndEndSpan)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $235f065844cb7e84$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $8maFY.getActiveSpan)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $OEeFi.msToSec)((0, $iBQWV.browserPerformanceTimeOrigin) + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $8maFY.spanToJSON)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $OEeFi.msToSec)(entry.duration);
            const attributes = {
                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $OEeFi.startAndEndSpan)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $235f065844cb7e84$export$e27543e0976315e4() {
    (0, $4VX7K.addPerformanceInstrumentationHandler)("event", ({ entries: entries })=>{
        const parent = (0, $8maFY.getActiveSpan)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $OEeFi.msToSec)((0, $iBQWV.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = (0, $OEeFi.msToSec)(entry.duration);
            const spanOptions = {
                name: (0, $iv9z6.htmlTreeAsString)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $iv9z6.getComponentName)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $OEeFi.startAndEndSpan)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $235f065844cb7e84$var$_trackCLS() {
    return (0, $4VX7K.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $235f065844cb7e84$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $235f065844cb7e84$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $235f065844cb7e84$var$_trackLCP() {
    return (0, $4VX7K.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $235f065844cb7e84$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $235f065844cb7e84$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $235f065844cb7e84$var$_trackFID() {
    return (0, $4VX7K.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $OEeFi.msToSec)((0, $iBQWV.browserPerformanceTimeOrigin));
        const startTime = (0, $OEeFi.msToSec)(entry.startTime);
        $235f065844cb7e84$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $235f065844cb7e84$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $235f065844cb7e84$var$_trackTtfb() {
    return (0, $4VX7K.addTtfbInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $235f065844cb7e84$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
/** Add performance related spans to a transaction */ function $235f065844cb7e84$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $OEeFi.getBrowserPerformanceAPI)();
    if (!performance || !performance.getEntries || !(0, $iBQWV.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $OEeFi.msToSec)((0, $iBQWV.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $8maFY.spanToJSON)(span);
    performanceEntries.slice($235f065844cb7e84$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $OEeFi.msToSec)(entry.startTime);
        const duration = (0, $OEeFi.msToSec)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $235f065844cb7e84$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $235f065844cb7e84$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $gt3y1.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) $235f065844cb7e84$var$_measurements["fp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    if (entry.name === "first-contentful-paint" && shouldRecord) $235f065844cb7e84$var$_measurements["fcp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    break;
                }
            case "resource":
                $235f065844cb7e84$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $235f065844cb7e84$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $235f065844cb7e84$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $235f065844cb7e84$var$_addTtfbRequestTimeToMeasurements($235f065844cb7e84$var$_measurements);
        const fidMark = $235f065844cb7e84$var$_measurements["mark.fid"];
        if (fidMark && $235f065844cb7e84$var$_measurements["fid"]) {
            // create span for FID
            (0, $OEeFi.startAndEndSpan)(span, fidMark.value, fidMark.value + (0, $OEeFi.msToSec)($235f065844cb7e84$var$_measurements["fid"].value), {
                name: "first input delay",
                op: "ui.action",
                attributes: {
                    [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $235f065844cb7e84$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!("fcp" in $235f065844cb7e84$var$_measurements) || !options.recordClsOnPageloadSpan) delete $235f065844cb7e84$var$_measurements.cls;
        Object.entries($235f065844cb7e84$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $jljxN.setMeasurement)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute("performance.timeOrigin", timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute("performance.activationStart", (0, $5OMWF.getActivationStart)());
        $235f065844cb7e84$var$_setWebVitalAttributes(span);
    }
    $235f065844cb7e84$var$_lcpEntry = undefined;
    $235f065844cb7e84$var$_clsEntry = undefined;
    $235f065844cb7e84$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $235f065844cb7e84$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $dlxhi.getNavigationEntry)(false);
    const requestTime = (0, $OEeFi.msToSec)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    (0, $OEeFi.startAndEndSpan)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ function $235f065844cb7e84$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $235f065844cb7e84$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $235f065844cb7e84$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $235f065844cb7e84$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $235f065844cb7e84$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $235f065844cb7e84$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $235f065844cb7e84$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $235f065844cb7e84$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $OEeFi.startAndEndSpan)(span, timeOrigin + (0, $OEeFi.msToSec)(start), timeOrigin + (0, $OEeFi.msToSec)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
        }
    });
}
function $235f065844cb7e84$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
/** Create request and response related spans */ function $235f065844cb7e84$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $OEeFi.msToSec)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $OEeFi.msToSec)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $OEeFi.msToSec)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $OEeFi.startAndEndSpan)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
            }
        });
        (0, $OEeFi.startAndEndSpan)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $235f065844cb7e84$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $iQ90U.parseUrl)(resourceUrl);
    const attributes = {
        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.resource.browser.metrics"
    };
    $235f065844cb7e84$var$setResourceEntrySizeData(attributes, entry, "transferSize", "http.response_transfer_size");
    $235f065844cb7e84$var$setResourceEntrySizeData(attributes, entry, "encodedBodySize", "http.response_content_length");
    $235f065844cb7e84$var$setResourceEntrySizeData(attributes, entry, "decodedBodySize", "http.decoded_response_content_length");
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes["http.response_delivery_type"] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes["resource.render_blocking_status"] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $2z9m4.WINDOW).location.origin);
    const { name: name, version: version } = (0, $OEeFi.extractNetworkProtocol)(entry.nextHopProtocol);
    attributes["network.protocol.name"] = name;
    attributes["network.protocol.version"] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $OEeFi.startAndEndSpan)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $2z9m4.WINDOW).location.origin, ""),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $235f065844cb7e84$var$_trackNavigator(span) {
    const navigator = (0, $2z9m4.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute("effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute("connectionType", connection.type);
        if ((0, $OEeFi.isMeasurementValue)(connection.rtt)) $235f065844cb7e84$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $OEeFi.isMeasurementValue)(navigator.deviceMemory)) span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $OEeFi.isMeasurementValue)(navigator.hardwareConcurrency)) span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $235f065844cb7e84$var$_setWebVitalAttributes(span) {
    if ($235f065844cb7e84$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($235f065844cb7e84$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $iv9z6.htmlTreeAsString)($235f065844cb7e84$var$_lcpEntry.element));
        if ($235f065844cb7e84$var$_lcpEntry.id) span.setAttribute("lcp.id", $235f065844cb7e84$var$_lcpEntry.id);
        if ($235f065844cb7e84$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute("lcp.url", $235f065844cb7e84$var$_lcpEntry.url.trim().slice(0, 200));
        if ($235f065844cb7e84$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute("lcp.loadTime", $235f065844cb7e84$var$_lcpEntry.loadTime);
        if ($235f065844cb7e84$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute("lcp.renderTime", $235f065844cb7e84$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $235f065844cb7e84$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($235f065844cb7e84$var$_clsEntry && $235f065844cb7e84$var$_clsEntry.sources) $235f065844cb7e84$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $iv9z6.htmlTreeAsString)(source.node)));
}
function $235f065844cb7e84$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $235f065844cb7e84$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $235f065844cb7e84$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $dlxhi.getNavigationEntry)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}

});
parcelRegister("jljxN", function(module, exports) {

$parcel$export(module.exports, "setMeasurement", function () { return $e14f238597f3ee05$export$7cc31b475d33a706; });
$parcel$export(module.exports, "timedEventsToMeasurements", function () { return $e14f238597f3ee05$export$487db6fcdf36893e; });

var $ilsq0 = parcelRequire("ilsq0");

var $c29ht = parcelRequire("c29ht");

var $4vOpL = parcelRequire("4vOpL");

var $8maFY = parcelRequire("8maFY");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $e14f238597f3ee05$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $8maFY.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, $8maFY.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $e14f238597f3ee05$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}

});

parcelRegister("2Mebr", function(module, exports) {

$parcel$export(module.exports, "trackClsAsStandaloneSpan", function () { return $205b1102420d3772$export$585bab03c6c18c45; });

var $3HlBY = parcelRequire("3HlBY");
var $8maFY = parcelRequire("8maFY");
var $4vOpL = parcelRequire("4vOpL");
var $iBQWV = parcelRequire("iBQWV");
var $iv9z6 = parcelRequire("iv9z6");
var $6qGSh = parcelRequire("6qGSh");
var $c29ht = parcelRequire("c29ht");

var $44HcR = parcelRequire("44HcR");

var $4VX7K = parcelRequire("4VX7K");

var $OEeFi = parcelRequire("OEeFi");

var $iqPcc = parcelRequire("iqPcc");
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $205b1102420d3772$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$205b1102420d3772$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $205b1102420d3772$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $4VX7K.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $iqPcc.onHidden)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $3HlBY.getClient)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on("startNavigationSpan", ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation && unsubscribeStartNavigation();
        });
        const activeSpan = (0, $8maFY.getActiveSpan)();
        const rootSpan = activeSpan && (0, $8maFY.getRootSpan)(activeSpan);
        const spanJSON = rootSpan && (0, $8maFY.spanToJSON)(rootSpan);
        if (spanJSON && spanJSON.op === "pageload") pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $205b1102420d3772$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $44HcR.DEBUG_BUILD) && (0, $4vOpL.logger).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $OEeFi.msToSec)(((0, $iBQWV.browserPerformanceTimeOrigin) || 0) + (entry && entry.startTime || 0));
    const routeName = (0, $3HlBY.getCurrentScope)().getScopeData().transactionName;
    const name = entry ? (0, $iv9z6.htmlTreeAsString)(entry.sources[0] && entry.sources[0].node) : "Layout shift";
    const attributes = (0, $6qGSh.dropUndefinedKeys)({
        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser.cls",
        [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "ui.webvital.cls",
        [(0, $c29ht.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry && entry.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId
    });
    const span = (0, $OEeFi.startStandaloneWebVitalSpan)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: "",
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $205b1102420d3772$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes("layout-shift");
    } catch (e) {
        return false;
    }
}

});
parcelRegister("4VX7K", function(module, exports) {

$parcel$export(module.exports, "addClsInstrumentationHandler", function () { return $397a591a698b2272$export$861b82818b37ba5b; });
$parcel$export(module.exports, "addLcpInstrumentationHandler", function () { return $397a591a698b2272$export$3fd4b53331200102; });
$parcel$export(module.exports, "addFidInstrumentationHandler", function () { return $397a591a698b2272$export$2707d7471c0b918f; });
$parcel$export(module.exports, "addTtfbInstrumentationHandler", function () { return $397a591a698b2272$export$699d9529c099a797; });
$parcel$export(module.exports, "addInpInstrumentationHandler", function () { return $397a591a698b2272$export$da3b76aa2022cbd7; });
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", function () { return $397a591a698b2272$export$69816c1a049f8db6; });
$parcel$export(module.exports, "isPerformanceEventTiming", function () { return $397a591a698b2272$export$7affb50b622d8714; });

var $4vOpL = parcelRequire("4vOpL");
var $3TBFY = parcelRequire("3TBFY");

var $44HcR = parcelRequire("44HcR");

var $7tJfv = parcelRequire("7tJfv");

var $kGkCt = parcelRequire("kGkCt");

var $4o7RJ = parcelRequire("4o7RJ");

var $a5jl6 = parcelRequire("a5jl6");

var $5Aqp9 = parcelRequire("5Aqp9");

var $5OMj3 = parcelRequire("5OMj3");
const $397a591a698b2272$var$handlers = {};
const $397a591a698b2272$var$instrumented = {};
let $397a591a698b2272$var$_previousCls;
let $397a591a698b2272$var$_previousFid;
let $397a591a698b2272$var$_previousLcp;
let $397a591a698b2272$var$_previousTtfb;
let $397a591a698b2272$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $397a591a698b2272$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $397a591a698b2272$var$addMetricObserver("cls", callback, $397a591a698b2272$var$instrumentCls, $397a591a698b2272$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $397a591a698b2272$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $397a591a698b2272$var$addMetricObserver("lcp", callback, $397a591a698b2272$var$instrumentLcp, $397a591a698b2272$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $397a591a698b2272$export$2707d7471c0b918f(callback) {
    return $397a591a698b2272$var$addMetricObserver("fid", callback, $397a591a698b2272$var$instrumentFid, $397a591a698b2272$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $397a591a698b2272$export$699d9529c099a797(callback) {
    return $397a591a698b2272$var$addMetricObserver("ttfb", callback, $397a591a698b2272$var$instrumentTtfb, $397a591a698b2272$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $397a591a698b2272$export$da3b76aa2022cbd7(callback) {
    return $397a591a698b2272$var$addMetricObserver("inp", callback, $397a591a698b2272$var$instrumentInp, $397a591a698b2272$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $397a591a698b2272$export$69816c1a049f8db6(type, callback) {
    $397a591a698b2272$var$addHandler(type, callback);
    if (!$397a591a698b2272$var$instrumented[type]) {
        $397a591a698b2272$var$instrumentPerformanceObserver(type);
        $397a591a698b2272$var$instrumented[type] = true;
    }
    return $397a591a698b2272$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $397a591a698b2272$var$triggerHandlers(type, data) {
    const typeHandlers = $397a591a698b2272$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $44HcR.DEBUG_BUILD) && (0, $4vOpL.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $3TBFY.getFunctionName)(handler)}\nError:`, e);
    }
}
function $397a591a698b2272$var$instrumentCls() {
    return (0, $7tJfv.onCLS)((metric)=>{
        $397a591a698b2272$var$triggerHandlers("cls", {
            metric: metric
        });
        $397a591a698b2272$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $397a591a698b2272$var$instrumentFid() {
    return (0, $kGkCt.onFID)((metric)=>{
        $397a591a698b2272$var$triggerHandlers("fid", {
            metric: metric
        });
        $397a591a698b2272$var$_previousFid = metric;
    });
}
function $397a591a698b2272$var$instrumentLcp() {
    return (0, $a5jl6.onLCP)((metric)=>{
        $397a591a698b2272$var$triggerHandlers("lcp", {
            metric: metric
        });
        $397a591a698b2272$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $397a591a698b2272$var$instrumentTtfb() {
    return (0, $5OMj3.onTTFB)((metric)=>{
        $397a591a698b2272$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $397a591a698b2272$var$_previousTtfb = metric;
    });
}
function $397a591a698b2272$var$instrumentInp() {
    return (0, $4o7RJ.onINP)((metric)=>{
        $397a591a698b2272$var$triggerHandlers("inp", {
            metric: metric
        });
        $397a591a698b2272$var$_previousInp = metric;
    });
}
function $397a591a698b2272$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $397a591a698b2272$var$addHandler(type, callback);
    let stopListening;
    if (!$397a591a698b2272$var$instrumented[type]) {
        stopListening = instrumentFn();
        $397a591a698b2272$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $397a591a698b2272$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $397a591a698b2272$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $5Aqp9.observe)(type, (entries)=>{
        $397a591a698b2272$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $397a591a698b2272$var$addHandler(type, handler) {
    $397a591a698b2272$var$handlers[type] = $397a591a698b2272$var$handlers[type] || [];
    $397a591a698b2272$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $397a591a698b2272$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $397a591a698b2272$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $397a591a698b2272$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}

});
parcelRegister("7tJfv", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $571e575865162fa0$export$a7873055838e5ad8; });

var $i7Nyg = parcelRequire("i7Nyg");

var $lzRJI = parcelRequire("lzRJI");

var $5Aqp9 = parcelRequire("5Aqp9");

var $iqPcc = parcelRequire("iqPcc");

var $kkIql = parcelRequire("kkIql");

var $8DHuF = parcelRequire("8DHuF");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $571e575865162fa0$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $571e575865162fa0$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $8DHuF.onFCP)((0, $kkIql.runOnce)(()=>{
        const metric = (0, $lzRJI.initMetric)("CLS", 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $5Aqp9.observe)("layout-shift", handleEntries);
        if (po) {
            report = (0, $i7Nyg.bindReporter)(onReport, metric, $571e575865162fa0$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $iqPcc.onHidden)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};

});
parcelRegister("i7Nyg", function(module, exports) {

$parcel$export(module.exports, "bindReporter", function () { return $0367bb1e66e3644c$export$17679dccdd551979; });
const $0367bb1e66e3644c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $0367bb1e66e3644c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $0367bb1e66e3644c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("lzRJI", function(module, exports) {

$parcel$export(module.exports, "initMetric", function () { return $fb568cc575d827c6$export$3c29b44508a0612b; });

var $2z9m4 = parcelRequire("2z9m4");

var $jOoeD = parcelRequire("jOoeD");

var $5OMWF = parcelRequire("5OMWF");

var $dlxhi = parcelRequire("dlxhi");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fb568cc575d827c6$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $dlxhi.getNavigationEntry)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $2z9m4.WINDOW).document && (0, $2z9m4.WINDOW).document.prerendering || (0, $5OMWF.getActivationStart)() > 0) navigationType = "prerender";
        else if ((0, $2z9m4.WINDOW).document && (0, $2z9m4.WINDOW).document.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $jOoeD.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("jOoeD", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", function () { return $e6c57c62360a9e14$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $e6c57c62360a9e14$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("5OMWF", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", function () { return $43c796c5ab593e76$export$d3e828b3c7b5b845; });

var $dlxhi = parcelRequire("dlxhi");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $43c796c5ab593e76$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $dlxhi.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("dlxhi", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $9b770cd9d3bb52cb$export$6431553786c94949; });

var $2z9m4 = parcelRequire("2z9m4");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $9b770cd9d3bb52cb$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $2z9m4.WINDOW).performance && (0, $2z9m4.WINDOW).performance.getEntriesByType && (0, $2z9m4.WINDOW).performance.getEntriesByType("navigation")[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};

});



parcelRegister("5Aqp9", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $4114cbfb2f184cfd$export$d1203567a167490e; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $4114cbfb2f184cfd$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("iqPcc", function(module, exports) {

$parcel$export(module.exports, "onHidden", function () { return $d6b25e20a96d4a08$export$91ec2be6fdd8f1b4; });

var $2z9m4 = parcelRequire("2z9m4");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $d6b25e20a96d4a08$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $2z9m4.WINDOW).document && (0, $2z9m4.WINDOW).document.visibilityState === "hidden") cb(event);
    };
    if ((0, $2z9m4.WINDOW).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};

});

parcelRegister("kkIql", function(module, exports) {

$parcel$export(module.exports, "runOnce", function () { return $ecd8228c53c4c72e$export$b841d51e31c12bab; });
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ecd8228c53c4c72e$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});

parcelRegister("8DHuF", function(module, exports) {

$parcel$export(module.exports, "onFCP", function () { return $64a3b42b9cd85da7$export$fe3c86b74e15d5de; });

var $i7Nyg = parcelRequire("i7Nyg");

var $5OMWF = parcelRequire("5OMWF");

var $gt3y1 = parcelRequire("gt3y1");

var $lzRJI = parcelRequire("lzRJI");

var $5Aqp9 = parcelRequire("5Aqp9");

var $8bqRx = parcelRequire("8bqRx");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $64a3b42b9cd85da7$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $64a3b42b9cd85da7$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $8bqRx.whenActivated)(()=>{
        const visibilityWatcher = (0, $gt3y1.getVisibilityWatcher)();
        const metric = (0, $lzRJI.initMetric)("FCP");
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === "first-contentful-paint") {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $5OMWF.getActivationStart)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $5Aqp9.observe)("paint", handleEntries);
        if (po) report = (0, $i7Nyg.bindReporter)(onReport, metric, $64a3b42b9cd85da7$export$e610c735b5510cec, opts.reportAllChanges);
    });
};

});
parcelRegister("gt3y1", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", function () { return $bfd21b4cdb95c7b9$export$443f86b2c77012c4; });

var $2z9m4 = parcelRequire("2z9m4");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bfd21b4cdb95c7b9$var$firstHiddenTime = -1;
const $bfd21b4cdb95c7b9$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $2z9m4.WINDOW).document.visibilityState === "hidden" && !(0, $2z9m4.WINDOW).document.prerendering ? 0 : Infinity;
};
const $bfd21b4cdb95c7b9$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $2z9m4.WINDOW).document.visibilityState === "hidden" && $bfd21b4cdb95c7b9$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bfd21b4cdb95c7b9$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $bfd21b4cdb95c7b9$var$removeChangeListeners();
    }
};
const $bfd21b4cdb95c7b9$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $bfd21b4cdb95c7b9$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $bfd21b4cdb95c7b9$var$onVisibilityUpdate, true);
};
const $bfd21b4cdb95c7b9$var$removeChangeListeners = ()=>{
    removeEventListener("visibilitychange", $bfd21b4cdb95c7b9$var$onVisibilityUpdate, true);
    removeEventListener("prerenderingchange", $bfd21b4cdb95c7b9$var$onVisibilityUpdate, true);
};
const $bfd21b4cdb95c7b9$export$443f86b2c77012c4 = ()=>{
    if ((0, $2z9m4.WINDOW).document && $bfd21b4cdb95c7b9$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bfd21b4cdb95c7b9$var$firstHiddenTime = $bfd21b4cdb95c7b9$var$initHiddenTime();
        $bfd21b4cdb95c7b9$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bfd21b4cdb95c7b9$var$firstHiddenTime;
        }
    };
};

});

parcelRegister("8bqRx", function(module, exports) {

$parcel$export(module.exports, "whenActivated", function () { return $5f543021cd41d912$export$8bdb38a5671b594e; });

var $2z9m4 = parcelRequire("2z9m4");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5f543021cd41d912$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $2z9m4.WINDOW).document && (0, $2z9m4.WINDOW).document.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};

});



parcelRegister("kGkCt", function(module, exports) {

$parcel$export(module.exports, "onFID", function () { return $f0e7b9833f4d048e$export$39705a25c49af873; });

var $i7Nyg = parcelRequire("i7Nyg");

var $gt3y1 = parcelRequire("gt3y1");

var $lzRJI = parcelRequire("lzRJI");

var $5Aqp9 = parcelRequire("5Aqp9");

var $iqPcc = parcelRequire("iqPcc");

var $kkIql = parcelRequire("kkIql");

var $8bqRx = parcelRequire("8bqRx");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $f0e7b9833f4d048e$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $f0e7b9833f4d048e$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $8bqRx.whenActivated)(()=>{
        const visibilityWatcher = (0, $gt3y1.getVisibilityWatcher)();
        const metric = (0, $lzRJI.initMetric)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $5Aqp9.observe)("first-input", handleEntries);
        report = (0, $i7Nyg.bindReporter)(onReport, metric, $f0e7b9833f4d048e$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $iqPcc.onHidden)((0, $kkIql.runOnce)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};

});

parcelRegister("4o7RJ", function(module, exports) {

$parcel$export(module.exports, "onINP", function () { return $331f8146d4f20b91$export$7df4b36ecaed99e1; });

var $2z9m4 = parcelRequire("2z9m4");

var $i7Nyg = parcelRequire("i7Nyg");

var $lzRJI = parcelRequire("lzRJI");

var $2RQqM = parcelRequire("2RQqM");

var $5Aqp9 = parcelRequire("5Aqp9");

var $iqPcc = parcelRequire("iqPcc");

var $lBNtA = parcelRequire("lBNtA");

var $8bqRx = parcelRequire("8bqRx");

var $bOe9E = parcelRequire("bOe9E");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $331f8146d4f20b91$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $331f8146d4f20b91$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!("PerformanceEventTiming" in (0, $2z9m4.WINDOW) && "interactionId" in PerformanceEventTiming.prototype)) return;
    (0, $8bqRx.whenActivated)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $lBNtA.initInteractionCountPolyfill)();
        const metric = (0, $lzRJI.initMetric)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $bOe9E.whenIdle)(()=>{
                entries.forEach((0, $2RQqM.processInteractionEntry));
                const inp = (0, $2RQqM.estimateP98LongestInteraction)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $5Aqp9.observe)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $2RQqM.DEFAULT_DURATION_THRESHOLD)
        });
        report = (0, $i7Nyg.bindReporter)(onReport, metric, $331f8146d4f20b91$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: "first-input",
                buffered: true
            });
            (0, $iqPcc.onHidden)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};

});
parcelRegister("2RQqM", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DURATION_THRESHOLD", function () { return $216933b9de1094a5$export$9cebd8cf5d8d3416; });
$parcel$export(module.exports, "estimateP98LongestInteraction", function () { return $216933b9de1094a5$export$70cf089971ed4f82; });
$parcel$export(module.exports, "processInteractionEntry", function () { return $216933b9de1094a5$export$6a7a48c2c643798f; });

var $lBNtA = parcelRequire("lBNtA");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $216933b9de1094a5$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $216933b9de1094a5$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $216933b9de1094a5$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $216933b9de1094a5$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $216933b9de1094a5$var$getInteractionCountForNavigation = ()=>{
    return (0, $lBNtA.getInteractionCount)() - $216933b9de1094a5$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $216933b9de1094a5$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($216933b9de1094a5$export$fbb6a65efb09cd7a.length - 1, Math.floor($216933b9de1094a5$var$getInteractionCountForNavigation() / 50));
    return $216933b9de1094a5$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $216933b9de1094a5$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $216933b9de1094a5$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $216933b9de1094a5$export$6a7a48c2c643798f = (entry)=>{
    $216933b9de1094a5$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === "first-input")) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $216933b9de1094a5$export$fbb6a65efb09cd7a[$216933b9de1094a5$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $216933b9de1094a5$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $216933b9de1094a5$export$fbb6a65efb09cd7a.length < $216933b9de1094a5$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === (existingInteraction.entries[0] && existingInteraction.entries[0].startTime)) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $216933b9de1094a5$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $216933b9de1094a5$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $216933b9de1094a5$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($216933b9de1094a5$export$fbb6a65efb09cd7a.length > $216933b9de1094a5$var$MAX_INTERACTIONS_TO_CONSIDER) $216933b9de1094a5$export$fbb6a65efb09cd7a.splice($216933b9de1094a5$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$216933b9de1094a5$export$7b86959c9ded44e2.delete(i.id));
    }
};

});
parcelRegister("lBNtA", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", function () { return $fbb36e9923d612bf$export$8a962f2683a476d1; });
$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $fbb36e9923d612bf$export$67d90cda6b78a2eb; });

var $5Aqp9 = parcelRequire("5Aqp9");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $fbb36e9923d612bf$var$interactionCountEstimate = 0;
let $fbb36e9923d612bf$var$minKnownInteractionId = Infinity;
let $fbb36e9923d612bf$var$maxKnownInteractionId = 0;
const $fbb36e9923d612bf$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $fbb36e9923d612bf$var$minKnownInteractionId = Math.min($fbb36e9923d612bf$var$minKnownInteractionId, e.interactionId);
            $fbb36e9923d612bf$var$maxKnownInteractionId = Math.max($fbb36e9923d612bf$var$maxKnownInteractionId, e.interactionId);
            $fbb36e9923d612bf$var$interactionCountEstimate = $fbb36e9923d612bf$var$maxKnownInteractionId ? ($fbb36e9923d612bf$var$maxKnownInteractionId - $fbb36e9923d612bf$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $fbb36e9923d612bf$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $fbb36e9923d612bf$export$8a962f2683a476d1 = ()=>{
    return $fbb36e9923d612bf$var$po ? $fbb36e9923d612bf$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $fbb36e9923d612bf$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $fbb36e9923d612bf$var$po) return;
    $fbb36e9923d612bf$var$po = (0, $5Aqp9.observe)("event", $fbb36e9923d612bf$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("bOe9E", function(module, exports) {

$parcel$export(module.exports, "whenIdle", function () { return $898f58078a7052ab$export$4d9952dcbf5b2792; });

var $2z9m4 = parcelRequire("2z9m4");

var $iqPcc = parcelRequire("iqPcc");

var $kkIql = parcelRequire("kkIql");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $898f58078a7052ab$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $2z9m4.WINDOW).requestIdleCallback || (0, $2z9m4.WINDOW).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $kkIql.runOnce)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $2z9m4.WINDOW).document && (0, $2z9m4.WINDOW).document.visibilityState === "hidden") cb();
    else {
        handle = rIC(cb);
        (0, $iqPcc.onHidden)(cb);
    }
    return handle;
};

});


parcelRegister("a5jl6", function(module, exports) {

$parcel$export(module.exports, "onLCP", function () { return $75795f62be0e7540$export$947b1626ab8d5632; });

var $2z9m4 = parcelRequire("2z9m4");

var $i7Nyg = parcelRequire("i7Nyg");

var $5OMWF = parcelRequire("5OMWF");

var $gt3y1 = parcelRequire("gt3y1");

var $lzRJI = parcelRequire("lzRJI");

var $5Aqp9 = parcelRequire("5Aqp9");

var $iqPcc = parcelRequire("iqPcc");

var $kkIql = parcelRequire("kkIql");

var $8bqRx = parcelRequire("8bqRx");

var $bOe9E = parcelRequire("bOe9E");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $75795f62be0e7540$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $75795f62be0e7540$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $75795f62be0e7540$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $8bqRx.whenActivated)(()=>{
        const visibilityWatcher = (0, $gt3y1.getVisibilityWatcher)();
        const metric = (0, $lzRJI.initMetric)("LCP");
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $5OMWF.getActivationStart)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $5Aqp9.observe)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $i7Nyg.bindReporter)(onReport, metric, $75795f62be0e7540$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $kkIql.runOnce)(()=>{
                if (!$75795f62be0e7540$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $75795f62be0e7540$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                "keydown",
                "click"
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $2z9m4.WINDOW).document) addEventListener(type, ()=>(0, $bOe9E.whenIdle)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $iqPcc.onHidden)(stopListening);
        }
    });
};

});

parcelRegister("5OMj3", function(module, exports) {

$parcel$export(module.exports, "onTTFB", function () { return $43c717e9cafd5a1a$export$33a01e6c5f2c7e33; });

var $2z9m4 = parcelRequire("2z9m4");

var $i7Nyg = parcelRequire("i7Nyg");

var $5OMWF = parcelRequire("5OMWF");

var $dlxhi = parcelRequire("dlxhi");

var $lzRJI = parcelRequire("lzRJI");

var $8bqRx = parcelRequire("8bqRx");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $43c717e9cafd5a1a$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $43c717e9cafd5a1a$var$whenReady = (callback)=>{
    if ((0, $2z9m4.WINDOW).document && (0, $2z9m4.WINDOW).document.prerendering) (0, $8bqRx.whenActivated)(()=>$43c717e9cafd5a1a$var$whenReady(callback));
    else if ((0, $2z9m4.WINDOW).document && (0, $2z9m4.WINDOW).document.readyState !== "complete") addEventListener("load", ()=>$43c717e9cafd5a1a$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $43c717e9cafd5a1a$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $lzRJI.initMetric)("TTFB");
    const report = (0, $i7Nyg.bindReporter)(onReport, metric, $43c717e9cafd5a1a$export$65c59ea8064668fc, opts.reportAllChanges);
    $43c717e9cafd5a1a$var$whenReady(()=>{
        const navigationEntry = (0, $dlxhi.getNavigationEntry)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $5OMWF.getActivationStart)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};

});


parcelRegister("OEeFi", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", function () { return $0983e190ca6d57ff$export$27169ccae1b439e3; });
$parcel$export(module.exports, "startAndEndSpan", function () { return $0983e190ca6d57ff$export$7567a67bdb69a23d; });
$parcel$export(module.exports, "startStandaloneWebVitalSpan", function () { return $0983e190ca6d57ff$export$b71b9c7b60c5a4aa; });
$parcel$export(module.exports, "getBrowserPerformanceAPI", function () { return $0983e190ca6d57ff$export$f72a13c439a30cab; });
$parcel$export(module.exports, "msToSec", function () { return $0983e190ca6d57ff$export$b4785dbd4a81b33f; });
$parcel$export(module.exports, "extractNetworkProtocol", function () { return $0983e190ca6d57ff$export$57c6f824442f9fe1; });

var $9bD3z = parcelRequire("9bD3z");

var $iEcfy = parcelRequire("iEcfy");

var $jHMUv = parcelRequire("jHMUv");

var $8maFY = parcelRequire("8maFY");
var $iYyVD = parcelRequire("iYyVD");
var $3HlBY = parcelRequire("3HlBY");

var $2z9m4 = parcelRequire("2z9m4");
/**
 * Checks if a given value is a valid measurement value.
 */ function $0983e190ca6d57ff$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $0983e190ca6d57ff$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, _param) {
    var ctx = (0, $9bD3z._)({}, (0, $iEcfy._)(_param));
    const parentStartTime = (0, $8maFY.spanToJSON)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $iYyVD.withActiveSpan)(parentSpan, ()=>{
        const span = (0, $iYyVD.startInactiveSpan)((0, $jHMUv._)({
            startTime: startTimeInSeconds
        }, ctx));
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $0983e190ca6d57ff$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $3HlBY.getClient)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay && replay.getReplayId();
    const scope = (0, $3HlBY.getCurrentScope)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = (0, $jHMUv._)({
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $2z9m4.WINDOW).navigator && (0, $2z9m4.WINDOW).navigator.userAgent
    }, passedAttributes);
    return (0, $iYyVD.startInactiveSpan)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $0983e190ca6d57ff$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $2z9m4.WINDOW) && (0, $2z9m4.WINDOW).addEventListener && (0, $2z9m4.WINDOW).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $0983e190ca6d57ff$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $0983e190ca6d57ff$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}

});
parcelRegister("9bD3z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6b036ff8854e4bb4$export$71511d61b312f219; });
function $6b036ff8854e4bb4$export$71511d61b312f219() {
    $6b036ff8854e4bb4$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6b036ff8854e4bb4$export$71511d61b312f219.apply(this, arguments);
}

});

parcelRegister("iEcfy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d93576f8eef5e9d7$export$71511d61b312f219; });
function $d93576f8eef5e9d7$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

});

parcelRegister("iYyVD", function(module, exports) {

$parcel$export(module.exports, "startInactiveSpan", function () { return $dd08ecac0a02ede4$export$63dbba021a6b4047; });
$parcel$export(module.exports, "withActiveSpan", function () { return $dd08ecac0a02ede4$export$e57ac09b143d92a2; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $3dQJg = parcelRequire("3dQJg");

var $3HlBY = parcelRequire("3HlBY");

var $33sJY = parcelRequire("33sJY");

var $ilsq0 = parcelRequire("ilsq0");

var $c29ht = parcelRequire("c29ht");

var $4vOpL = parcelRequire("4vOpL");

var $01dJv = parcelRequire("01dJv");

var $fWlRu = parcelRequire("fWlRu");

var $12RAq = parcelRequire("12RAq");

var $34LSQ = parcelRequire("34LSQ");

var $fvhzj = parcelRequire("fvhzj");

var $8maFY = parcelRequire("8maFY");

var $cVl0G = parcelRequire("cVl0G");

var $dAfgh = parcelRequire("dAfgh");

var $iOhK6 = parcelRequire("iOhK6");

var $4x4kC = parcelRequire("4x4kC");

var $cx4wi = parcelRequire("cx4wi");

var $46vXT = parcelRequire("46vXT");

var $jvSHi = parcelRequire("jvSHi");
const $dd08ecac0a02ede4$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $dd08ecac0a02ede4$export$a1bd95187356f372(options, callback) {
    const acs = $dd08ecac0a02ede4$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $dd08ecac0a02ede4$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $3HlBY.withScope)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $dd08ecac0a02ede4$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $3HlBY.getCurrentScope)();
            const parentSpan = $dd08ecac0a02ede4$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $4x4kC.SentryNonRecordingSpan)() : $dd08ecac0a02ede4$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $fvhzj._setSpanForScope)(scope, activeSpan);
            return (0, $12RAq.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $8maFY.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $46vXT.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $dd08ecac0a02ede4$export$c10292ad04b92aea(options, callback) {
    const acs = $dd08ecac0a02ede4$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $dd08ecac0a02ede4$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $3HlBY.withScope)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $dd08ecac0a02ede4$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $3HlBY.getCurrentScope)();
            const parentSpan = $dd08ecac0a02ede4$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $4x4kC.SentryNonRecordingSpan)() : $dd08ecac0a02ede4$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $fvhzj._setSpanForScope)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $12RAq.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $8maFY.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $46vXT.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $dd08ecac0a02ede4$export$63dbba021a6b4047(options) {
    const acs = $dd08ecac0a02ede4$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $dd08ecac0a02ede4$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $3HlBY.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$dd08ecac0a02ede4$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $3HlBY.getCurrentScope)();
        const parentSpan = $dd08ecac0a02ede4$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $4x4kC.SentryNonRecordingSpan)();
        return $dd08ecac0a02ede4$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $dd08ecac0a02ede4$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $3dQJg.getMainCarrier)();
    const acs = (0, $33sJY.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $3HlBY.withScope)((scope)=>{
        const propagationContext = (0, $fWlRu.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $dd08ecac0a02ede4$export$e57ac09b143d92a2(span, callback) {
    const acs = $dd08ecac0a02ede4$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $3HlBY.withScope)((scope)=>{
        (0, $fvhzj._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $dd08ecac0a02ede4$export$869298f9835abc68(callback) {
    const acs = $dd08ecac0a02ede4$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $3HlBY.withScope)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$dd08ecac0a02ede4$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $dd08ecac0a02ede4$export$f90b03291402f553(callback) {
    return (0, $3HlBY.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $01dJv.generateTraceId)()
        });
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $dd08ecac0a02ede4$export$e57ac09b143d92a2(null, callback);
    });
}
function $dd08ecac0a02ede4$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $34LSQ.hasTracingEnabled)()) return new (0, $4x4kC.SentryNonRecordingSpan)();
    const isolationScope = (0, $3HlBY.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $dd08ecac0a02ede4$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $8maFY.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $cVl0G.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $8maFY.spanIsSampled)(parentSpan);
        span = $dd08ecac0a02ede4$var$_startRootSpan((0, $jHMUv._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, parentSampled);
        (0, $cVl0G.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = (0, $jHMUv._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        span = $dd08ecac0a02ede4$var$_startRootSpan((0, $jHMUv._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, parentSampled);
        if (dsc) (0, $cVl0G.freezeDscOnSpan)(span, dsc);
    }
    (0, $dAfgh.logSpanStart)(span);
    (0, $jvSHi.setCapturedScopesOnSpan)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $dd08ecac0a02ede4$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = (0, $jHMUv._)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        const ctx = (0, $jHMUv._)({}, initialCtx);
        ctx.startTimestamp = (0, $8maFY.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $dd08ecac0a02ede4$var$getAcs() {
    const carrier = (0, $3dQJg.getMainCarrier)();
    return (0, $33sJY.getAsyncContextStrategy)(carrier);
}
function $dd08ecac0a02ede4$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $3HlBY.getClient)();
    const options = client && client.getOptions() || {};
    const { name: name = "", attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$dd08ecac0a02ede4$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $iOhK6.sampleSpan)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $cx4wi.SentrySpan)((0, $hYccX._)((0, $jHMUv._)({}, spanArguments), {
        attributes: (0, $jHMUv._)({
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom"
        }, spanArguments.attributes),
        sampled: sampled
    }));
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $dd08ecac0a02ede4$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$dd08ecac0a02ede4$var$SUPPRESS_TRACING_KEY] ? false : (0, $8maFY.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, $cx4wi.SentrySpan)((0, $hYccX._)((0, $jHMUv._)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new (0, $4x4kC.SentryNonRecordingSpan)({
        traceId: traceId
    });
    (0, $8maFY.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, $3HlBY.getClient)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $dd08ecac0a02ede4$var$getParentSpan(scope) {
    const span = (0, $fvhzj._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, $3HlBY.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $8maFY.getRootSpan)(span);
    return span;
}
function $dd08ecac0a02ede4$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $dd08ecac0a02ede4$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}

});
parcelRegister("12RAq", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $0c2f8b87bd8458ab$export$18ce21a8b7efd7e9; });

var $3xKQd = parcelRequire("3xKQd");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $0c2f8b87bd8458ab$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $0c2f8b87bd8458ab$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $0c2f8b87bd8458ab$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $3xKQd.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("dAfgh", function(module, exports) {

$parcel$export(module.exports, "logSpanStart", function () { return $9e3a79ccf0b44678$export$2f3d84e767c9592b; });
$parcel$export(module.exports, "logSpanEnd", function () { return $9e3a79ccf0b44678$export$b77c830667a4d630; });

var $ilsq0 = parcelRequire("ilsq0");

var $4vOpL = parcelRequire("4vOpL");

var $8maFY = parcelRequire("8maFY");
/**
 * Print a log message for a started span.
 */ function $9e3a79ccf0b44678$export$2f3d84e767c9592b(span) {
    if (!(0, $ilsq0.DEBUG_BUILD)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $8maFY.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $8maFY.spanIsSampled)(span);
    const rootSpan = (0, $8maFY.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $8maFY.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $4vOpL.logger).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $9e3a79ccf0b44678$export$b77c830667a4d630(span) {
    if (!(0, $ilsq0.DEBUG_BUILD)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $8maFY.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $8maFY.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $4vOpL.logger).log(msg);
}

});

parcelRegister("iOhK6", function(module, exports) {

$parcel$export(module.exports, "sampleSpan", function () { return $db1aa8d2acf532e1$export$5f833db634b217bb; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $3HlBY = parcelRequire("3HlBY");

var $ilsq0 = parcelRequire("ilsq0");

var $4vOpL = parcelRequire("4vOpL");

var $34LSQ = parcelRequire("34LSQ");

var $fhppk = parcelRequire("fhppk");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $db1aa8d2acf532e1$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $34LSQ.hasTracingEnabled)(options)) return [
        false
    ];
    // Casting this from unknown, as the type of `sdkProcessingMetadata` is only changed in v9 and `normalizedRequest` is set in SentryHttpInstrumentation
    const normalizedRequest = (0, $3HlBY.getIsolationScope)().getScopeData().sdkProcessingMetadata.normalizedRequest;
    const enhancedSamplingContext = (0, $hYccX._)((0, $jHMUv._)({}, samplingContext), {
        normalizedRequest: samplingContext.normalizedRequest || normalizedRequest
    });
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") sampleRate = options.tracesSampler(enhancedSamplingContext);
    else if (enhancedSamplingContext.parentSampled !== undefined) sampleRate = enhancedSamplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $fhppk.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}

});

parcelRegister("4x4kC", function(module, exports) {

$parcel$export(module.exports, "SentryNonRecordingSpan", function () { return $34cd9aa18c2975a0$export$d6636b700b76c516; });

var $01dJv = parcelRequire("01dJv");

var $8maFY = parcelRequire("8maFY");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $34cd9aa18c2975a0$export$d6636b700b76c516 {
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $8maFY.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $01dJv.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $01dJv.generateSpanId)();
    }
}

});

parcelRegister("cx4wi", function(module, exports) {

$parcel$export(module.exports, "SentrySpan", function () { return $91fc12afc268e68a$export$a92149b045260d9f; });

var $jHMUv = parcelRequire("jHMUv");

var $3HlBY = parcelRequire("3HlBY");

var $ilsq0 = parcelRequire("ilsq0");

var $2IrBH = parcelRequire("2IrBH");

var $k6n49 = parcelRequire("k6n49");

var $c29ht = parcelRequire("c29ht");

var $4vOpL = parcelRequire("4vOpL");

var $6qGSh = parcelRequire("6qGSh");

var $01dJv = parcelRequire("01dJv");

var $iBQWV = parcelRequire("iBQWV");

var $8maFY = parcelRequire("8maFY");

var $cVl0G = parcelRequire("cVl0G");

var $dAfgh = parcelRequire("dAfgh");

var $jljxN = parcelRequire("jljxN");

var $jvSHi = parcelRequire("jvSHi");
const $91fc12afc268e68a$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $91fc12afc268e68a$export$a92149b045260d9f {
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $8maFY.TRACE_FLAG_SAMPLED) : (0, $8maFY.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $8maFY.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $8maFY.spanTimeInputToSeconds)(endTimestamp);
        (0, $dAfgh.logSpanEnd)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $6qGSh.dropUndefinedKeys)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $8maFY.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $k6n49.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, $jljxN.timedEventsToMeasurements)(this._events),
            is_segment: this._isStandaloneSpan && (0, $8maFY.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $8maFY.getRootSpan)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("[Tracing] Adding an event to span:", name);
        const time = $91fc12afc268e68a$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $iBQWV.timestampInSeconds)();
        const attributes = $91fc12afc268e68a$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $8maFY.spanTimeInputToSeconds)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $3HlBY.getClient)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $8maFY.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $91fc12afc268e68a$var$sendSpanEnvelope((0, $2IrBH.createSpanEnvelope)([
                this
            ], client));
            else {
                (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $jvSHi.getCapturedScopesOnSpan)(this).scope || (0, $3HlBY.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$91fc12afc268e68a$var$isFullFinishedSpan((0, $8maFY.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $jvSHi.getCapturedScopesOnSpan)(this);
        const scope = capturedSpanScope || (0, $3HlBY.getCurrentScope)();
        const client = scope.getClient() || (0, $3HlBY.getClient)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $8maFY.getSpanDescendants)(this).filter((span)=>span !== this && !$91fc12afc268e68a$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $8maFY.spanToJSON)(span)).filter($91fc12afc268e68a$var$isFullFinishedSpan);
        const source = this._attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            span.data && delete span.data[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = (0, $jHMUv._)({
            contexts: {
                trace: (0, $8maFY.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $91fc12afc268e68a$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $91fc12afc268e68a$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: (0, $jHMUv._)({
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope
            }, (0, $6qGSh.dropUndefinedKeys)({
                dynamicSamplingContext: (0, $cVl0G.getDynamicSamplingContextFromSpan)(this)
            })),
            _metrics_summary: (0, $k6n49.getMetricSummaryJsonForSpan)(this)
        }, source && {
            transaction_info: {
                source: source
            }
        });
        const measurements = (0, $jljxN.timedEventsToMeasurements)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $01dJv.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $01dJv.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, $iBQWV.timestampInSeconds)();
        this._attributes = {};
        this.setAttributes((0, $jHMUv._)({
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "manual",
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op
        }, spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
}
function $91fc12afc268e68a$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $91fc12afc268e68a$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $91fc12afc268e68a$var$isStandaloneSpan(span) {
    return span instanceof $91fc12afc268e68a$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $91fc12afc268e68a$var$sendSpanEnvelope(envelope) {
    const client = (0, $3HlBY.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

});
parcelRegister("jvSHi", function(module, exports) {

$parcel$export(module.exports, "setCapturedScopesOnSpan", function () { return $e34b5750beb1a5a4$export$cddb4027e3b0dd66; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $e34b5750beb1a5a4$export$c08fbc656a245d03; });

var $6qGSh = parcelRequire("6qGSh");
const $e34b5750beb1a5a4$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $e34b5750beb1a5a4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $e34b5750beb1a5a4$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $6qGSh.addNonEnumerableProperty)(span, $e34b5750beb1a5a4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $6qGSh.addNonEnumerableProperty)(span, $e34b5750beb1a5a4$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $e34b5750beb1a5a4$export$c08fbc656a245d03(span) {
    return {
        scope: span[$e34b5750beb1a5a4$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$e34b5750beb1a5a4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});






parcelRegister("hSxVX", function(module, exports) {

$parcel$export(module.exports, "startTrackingINP", function () { return $d041cd5926b85f7a$export$f17d06681a4744a3; });
$parcel$export(module.exports, "registerInpInteractionListener", function () { return $d041cd5926b85f7a$export$e4e04d43e223cce2; });

var $iBQWV = parcelRequire("iBQWV");
var $8maFY = parcelRequire("8maFY");
var $3HlBY = parcelRequire("3HlBY");
var $iv9z6 = parcelRequire("iv9z6");
var $6qGSh = parcelRequire("6qGSh");
var $c29ht = parcelRequire("c29ht");

var $4VX7K = parcelRequire("4VX7K");

var $OEeFi = parcelRequire("OEeFi");
const $d041cd5926b85f7a$var$LAST_INTERACTIONS = [];
const $d041cd5926b85f7a$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $d041cd5926b85f7a$export$f17d06681a4744a3() {
    const performance = (0, $OEeFi.getBrowserPerformanceAPI)();
    if (performance && (0, $iBQWV.browserPerformanceTimeOrigin)) {
        const inpCallback = $d041cd5926b85f7a$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $d041cd5926b85f7a$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $d041cd5926b85f7a$var$_trackINP() {
    return (0, $4VX7K.addInpInstrumentationHandler)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $d041cd5926b85f7a$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $d041cd5926b85f7a$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $OEeFi.msToSec)((0, $iBQWV.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = (0, $OEeFi.msToSec)(metric.value);
        const activeSpan = (0, $8maFY.getActiveSpan)();
        const rootSpan = activeSpan ? (0, $8maFY.getRootSpan)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $d041cd5926b85f7a$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $8maFY.spanToJSON)(spanToUse).description : (0, $3HlBY.getCurrentScope)().getScopeData().transactionName;
        const name = (0, $iv9z6.htmlTreeAsString)(entry.target);
        const attributes = (0, $6qGSh.dropUndefinedKeys)({
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser.inp",
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: `ui.interaction.${interactionType}`,
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry.duration
        });
        const span = (0, $OEeFi.startStandaloneWebVitalSpan)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent("inp", {
                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: "millisecond",
                [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $d041cd5926b85f7a$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $8maFY.getActiveSpan)();
        const activeRootSpan = activeSpan && (0, $8maFY.getRootSpan)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $4VX7K.isPerformanceEventTiming)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($d041cd5926b85f7a$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($d041cd5926b85f7a$var$LAST_INTERACTIONS.length > 10) {
                const last = $d041cd5926b85f7a$var$LAST_INTERACTIONS.shift();
                $d041cd5926b85f7a$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $d041cd5926b85f7a$var$LAST_INTERACTIONS.push(interactionId);
            $d041cd5926b85f7a$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $4VX7K.addPerformanceInstrumentationHandler)("event", handleEntries);
    (0, $4VX7K.addPerformanceInstrumentationHandler)("first-input", handleEntries);
}

});

parcelRegister("bRl6w", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $8a2503caeaa3f73e$export$809a2b7987fd5306; });
$parcel$export(module.exports, "startIdleSpan", function () { return $8a2503caeaa3f73e$export$901bffd97bd52797; });

var $3HlBY = parcelRequire("3HlBY");

var $ilsq0 = parcelRequire("ilsq0");

var $c29ht = parcelRequire("c29ht");

var $4vOpL = parcelRequire("4vOpL");

var $iBQWV = parcelRequire("iBQWV");

var $34LSQ = parcelRequire("34LSQ");

var $fvhzj = parcelRequire("fvhzj");

var $8maFY = parcelRequire("8maFY");

var $4x4kC = parcelRequire("4x4kC");

var $46vXT = parcelRequire("46vXT");

var $iYyVD = parcelRequire("iYyVD");
const $8a2503caeaa3f73e$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $8a2503caeaa3f73e$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $8a2503caeaa3f73e$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $8a2503caeaa3f73e$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $8a2503caeaa3f73e$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $8a2503caeaa3f73e$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $8a2503caeaa3f73e$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $8a2503caeaa3f73e$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $8a2503caeaa3f73e$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $8a2503caeaa3f73e$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $3HlBY.getClient)();
    if (!client || !(0, $34LSQ.hasTracingEnabled)()) return new (0, $4x4kC.SentryNonRecordingSpan)();
    const scope = (0, $3HlBY.getCurrentScope)();
    const previousActiveSpan = (0, $8maFY.getActiveSpan)();
    const span = $8a2503caeaa3f73e$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $iBQWV.timestampInSeconds)();
            const spanEndTimestamp = (0, $8maFY.spanTimeInputToSeconds)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $8maFY.getSpanDescendants)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $8maFY.spanToJSON)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $8maFY.spanToJSON)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $8a2503caeaa3f73e$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $8a2503caeaa3f73e$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $iBQWV.timestampInSeconds)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $iBQWV.timestampInSeconds)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $fvhzj._setSpanForScope)(scope, previousActiveSpan);
        const spanJSON = (0, $8maFY.spanToJSON)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute((0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), _finishReason);
        (0, $4vOpL.logger).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $8maFY.getSpanDescendants)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $46vXT.SPAN_STATUS_ERROR),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $8maFY.spanToJSON)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $ilsq0.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $4vOpL.logger).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $4vOpL.logger).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $8maFY.removeChildSpanFromSpan)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $8maFY.spanToJSON)(startedSpan).timestamp) return;
        const allSpans = (0, $8maFY.getSpanDescendants)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $46vXT.SPAN_STATUS_ERROR),
                message: "deadline_exceeded"
            });
            _finishReason = $8a2503caeaa3f73e$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $8a2503caeaa3f73e$var$_startIdleSpan(options) {
    const span = (0, $iYyVD.startInactiveSpan)(options);
    (0, $fvhzj._setSpanForScope)((0, $3HlBY.getCurrentScope)(), span);
    (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log("[Tracing] Started span is an idle span");
    return span;
}

});

parcelRegister("iy15R", function(module, exports) {

$parcel$export(module.exports, "registerSpanErrorInstrumentation", function () { return $d80c402217b734e9$export$b0914730ee1f6c80; });

var $ilsq0 = parcelRequire("ilsq0");

var $lebw5 = parcelRequire("lebw5");

var $bicNP = parcelRequire("bicNP");

var $4vOpL = parcelRequire("4vOpL");

var $8maFY = parcelRequire("8maFY");

var $46vXT = parcelRequire("46vXT");
let $d80c402217b734e9$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $d80c402217b734e9$export$b0914730ee1f6c80() {
    if ($d80c402217b734e9$var$errorsInstrumented) return;
    $d80c402217b734e9$var$errorsInstrumented = true;
    (0, $lebw5.addGlobalErrorInstrumentationHandler)($d80c402217b734e9$var$errorCallback);
    (0, $bicNP.addGlobalUnhandledRejectionInstrumentationHandler)($d80c402217b734e9$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $d80c402217b734e9$var$errorCallback() {
    const activeSpan = (0, $8maFY.getActiveSpan)();
    const rootSpan = activeSpan && (0, $8maFY.getRootSpan)(activeSpan);
    if (rootSpan) {
        const message = "internal_error";
        (0, $ilsq0.DEBUG_BUILD) && (0, $4vOpL.logger).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $46vXT.SPAN_STATUS_ERROR),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d80c402217b734e9$var$errorCallback.tag = "sentry_tracingErrorCallback";

});

parcelRegister("cAnkP", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", function () { return $929af2ad834cd311$export$6f18f55521af71a1; });

var $8maFY = parcelRequire("8maFY");
var $4vOpL = parcelRequire("4vOpL");
var $46vXT = parcelRequire("46vXT");

var $TSWQd = parcelRequire("TSWQd");

var $cBmnW = parcelRequire("cBmnW");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $929af2ad834cd311$export$6f18f55521af71a1() {
    if ((0, $cBmnW.WINDOW) && (0, $cBmnW.WINDOW).document) (0, $cBmnW.WINDOW).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $8maFY.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $8maFY.getRootSpan)(activeSpan);
        if ((0, $cBmnW.WINDOW).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $8maFY.spanToJSON)(rootSpan);
            if (0, $TSWQd.DEBUG_BUILD) (0, $4vOpL.logger).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $46vXT.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $TSWQd.DEBUG_BUILD) && (0, $4vOpL.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}

});

parcelRegister("kg7Ib", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return $ebfb489d6c7b08a4$export$cc17fb3c0bc95cd7; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return $ebfb489d6c7b08a4$export$864489cb3478db3e; });

var $jHMUv = parcelRequire("jHMUv");

var $00147 = parcelRequire("00147");
var $4VX7K = parcelRequire("4VX7K");
var $OEeFi = parcelRequire("OEeFi");

var $3Lp9Q = parcelRequire("3Lp9Q");
var $7TCPg = parcelRequire("7TCPg");
var $iQ90U = parcelRequire("iQ90U");
var $8maFY = parcelRequire("8maFY");
var $iBQWV = parcelRequire("iBQWV");
var $j3Pr8 = parcelRequire("j3Pr8");
var $34LSQ = parcelRequire("34LSQ");
var $46vXT = parcelRequire("46vXT");
var $iYyVD = parcelRequire("iYyVD");
var $c29ht = parcelRequire("c29ht");
var $4x4kC = parcelRequire("4x4kC");
var $hnuoL = parcelRequire("hnuoL");

var $cBmnW = parcelRequire("cBmnW");
/** Options for Request Instrumentation */ const $ebfb489d6c7b08a4$var$responseToSpanId = new WeakMap();
const $ebfb489d6c7b08a4$var$spanIdToEndTimestamp = new Map();
const $ebfb489d6c7b08a4$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $ebfb489d6c7b08a4$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = (0, $jHMUv._)({
        traceFetch: $ebfb489d6c7b08a4$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $ebfb489d6c7b08a4$export$cc17fb3c0bc95cd7.traceXHR,
        trackFetchStreamPerformance: $ebfb489d6c7b08a4$export$cc17fb3c0bc95cd7.trackFetchStreamPerformance
    }, _options);
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$ebfb489d6c7b08a4$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === "transaction" && event.spans) event.spans.forEach((span)=>{
                if (span.op === "http.client") {
                    const updatedTimestamp = $ebfb489d6c7b08a4$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $ebfb489d6c7b08a4$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $3Lp9Q.addFetchEndInstrumentationHandler)((handlerData)=>{
            if (handlerData.response) {
                const span = $ebfb489d6c7b08a4$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $ebfb489d6c7b08a4$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $3Lp9Q.addFetchInstrumentationHandler)((handlerData)=>{
            const createdSpan = (0, $7TCPg.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $ebfb489d6c7b08a4$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $ebfb489d6c7b08a4$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $iQ90U.parseUrl)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
            }
            if (enableHTTPTimings && createdSpan) $ebfb489d6c7b08a4$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $00147.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $ebfb489d6c7b08a4$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $ebfb489d6c7b08a4$var$addHTTPTimings(createdSpan);
    });
}
function $ebfb489d6c7b08a4$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $ebfb489d6c7b08a4$var$addHTTPTimings(span) {
    const { url: url } = (0, $8maFY.spanToJSON)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $4VX7K.addPerformanceInstrumentationHandler)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($ebfb489d6c7b08a4$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $ebfb489d6c7b08a4$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $ebfb489d6c7b08a4$var$getAbsoluteTime(time = 0) {
    return (((0, $iBQWV.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $ebfb489d6c7b08a4$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $OEeFi.extractNetworkProtocol)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $iBQWV.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $ebfb489d6c7b08a4$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $ebfb489d6c7b08a4$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $cBmnW.WINDOW).location && (0, $cBmnW.WINDOW).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $j3Pr8.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $j3Pr8.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $j3Pr8.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $ebfb489d6c7b08a4$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $00147.SENTRY_XHR_DATA_KEY];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $34LSQ.hasTracingEnabled)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $46vXT.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $ebfb489d6c7b08a4$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $iQ90U.parseUrl)(fullUrl).host : undefined;
    const hasParent = !!(0, $8maFY.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $iYyVD.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client"
        }
    }) : new (0, $4x4kC.SentryNonRecordingSpan)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(sentryXhrData.url)) $ebfb489d6c7b08a4$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $34LSQ.hasTracingEnabled)() && hasParent ? span : undefined);
    return span;
}
function $ebfb489d6c7b08a4$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { "sentry-trace": sentryTrace, baggage: baggage } = (0, $hnuoL.getTraceData)({
        span: span
    });
    if (sentryTrace) $ebfb489d6c7b08a4$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $ebfb489d6c7b08a4$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("baggage", sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $ebfb489d6c7b08a4$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $cBmnW.WINDOW).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}

});
parcelRegister("7TCPg", function(module, exports) {

$parcel$export(module.exports, "instrumentFetchRequest", function () { return $5bfbc96f98d06b19$export$6d73c62358c655be; });

var $jHMUv = parcelRequire("jHMUv");

var $hYccX = parcelRequire("hYccX");

var $c29ht = parcelRequire("c29ht");


var $3xKQd = parcelRequire("3xKQd");





var $iQ90U = parcelRequire("iQ90U");

var $fqiC2 = parcelRequire("fqiC2");


var $34LSQ = parcelRequire("34LSQ");

var $8maFY = parcelRequire("8maFY");

var $4x4kC = parcelRequire("4x4kC");

var $46vXT = parcelRequire("46vXT");

var $iYyVD = parcelRequire("iYyVD");

var $hnuoL = parcelRequire("hnuoL");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $5bfbc96f98d06b19$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $34LSQ.hasTracingEnabled)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $5bfbc96f98d06b19$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $5bfbc96f98d06b19$var$getFullURL(url);
    const host = fullUrl ? (0, $iQ90U.parseUrl)(fullUrl).host : undefined;
    const hasParent = !!(0, $8maFY.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $iYyVD.startInactiveSpan)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
            [(0, $c29ht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client"
        }
    }) : new (0, $4x4kC.SentryNonRecordingSpan)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $5bfbc96f98d06b19$var$_addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $34LSQ.hasTracingEnabled)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */ function $5bfbc96f98d06b19$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $hnuoL.getTraceData)({
        span: span
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const headers = fetchOptionsObj.headers || ($5bfbc96f98d06b19$var$isRequest(request) ? request.headers : undefined);
    if (!headers) return (0, $jHMUv._)({}, traceHeaders);
    else if ($5bfbc96f98d06b19$var$isHeaders(headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set("sentry-trace", sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $5bfbc96f98d06b19$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set("baggage", // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
            } else newHeaders.set("baggage", baggage);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === "sentry-trace");
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === "baggage" && typeof header[1] === "string") {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $5bfbc96f98d06b19$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                "sentry-trace",
                sentryTrace
            ]
        ];
        if (baggage) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === "string" ? $5bfbc96f98d06b19$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === "");
        else if (existingBaggageHeader) newBaggageHeaders.push($5bfbc96f98d06b19$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (baggage) newBaggageHeaders.push(baggage);
        return (0, $hYccX._)((0, $jHMUv._)({}, headers), {
            "sentry-trace": sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        });
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 *
 * @deprecated This function will not be exported anymore in v9.
 */ function $5bfbc96f98d06b19$export$6717acf674206871(request, _client, _scope, fetchOptionsObj, span) {
    return $5bfbc96f98d06b19$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span);
}
function $5bfbc96f98d06b19$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $5bfbc96f98d06b19$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $46vXT.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $46vXT.SPAN_STATUS_ERROR),
        message: "internal_error"
    });
    span.end();
}
function $5bfbc96f98d06b19$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(",")// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split("=")[0].startsWith((0, $fqiC2.SENTRY_BAGGAGE_KEY_PREFIX))).join(",");
}
function $5bfbc96f98d06b19$var$isRequest(request) {
    return typeof Request !== "undefined" && (0, $3xKQd.isInstanceOf)(request, Request);
}
function $5bfbc96f98d06b19$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && (0, $3xKQd.isInstanceOf)(headers, Headers);
}

});
parcelRegister("hnuoL", function(module, exports) {

$parcel$export(module.exports, "getTraceData", function () { return $ca6c2a25b2f28fa1$export$dec8f001b9d982cb; });

var $33sJY = parcelRequire("33sJY");

var $3dQJg = parcelRequire("3dQJg");

var $3HlBY = parcelRequire("3HlBY");

var $kHMxW = parcelRequire("kHMxW");



var $4vOpL = parcelRequire("4vOpL");



var $8maFY = parcelRequire("8maFY");

var $fWlRu = parcelRequire("fWlRu");

var $cVl0G = parcelRequire("cVl0G");

var $fqiC2 = parcelRequire("fqiC2");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $ca6c2a25b2f28fa1$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $3HlBY.getClient)();
    if (!(0, $kHMxW.isEnabled)() || !client) return {};
    const carrier = (0, $3dQJg.getMainCarrier)();
    const acs = (0, $33sJY.getAsyncContextStrategy)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $3HlBY.getCurrentScope)();
    const span = options.span || (0, $8maFY.getActiveSpan)();
    const sentryTrace = span ? (0, $8maFY.spanToTraceHeader)(span) : $ca6c2a25b2f28fa1$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $cVl0G.getDynamicSamplingContextFromSpan)(span) : (0, $cVl0G.getDynamicSamplingContextFromScope)(client, scope);
    const baggage = (0, $fqiC2.dynamicSamplingContextToSentryBaggageHeader)(dsc);
    const isValidSentryTraceHeader = (0, $fWlRu.TRACEPARENT_REGEXP).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $4vOpL.logger).warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    return {
        "sentry-trace": sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $ca6c2a25b2f28fa1$var$scopeToTraceHeader(scope) {
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, sampled: sampled, spanId: spanId } = scope.getPropagationContext();
    return (0, $fWlRu.generateSentryTraceHeader)(traceId, spanId, sampled);
}

});






//# sourceMappingURL=sentry.module.e014235a.js.map
